// İlk önce CSS import
import '../../../context/AuthContext.css';

// Sonra React ve diğer kütüphane importları
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useAuth } from '../../../context/AuthContext';
import AccountSwitcher from '../../../components/AccountSwitcher';
import DateRangeFilter from '../../../components/filters/DateRangeFilter';
import Ga4WebOnlyNote from '../../../components/Ga4WebOnlyNote';
import { useAccounts } from '../../../context/AccountContext';
import { Card } from '../../../components/ui/Card';
import {
  Filter,
  Download,
  RefreshCw,
  Search,
  ChevronDown,
  ChevronRight,
  LayoutList,
  TrendingUp,
  DollarSign,
  MousePointerClick,
  ShoppingCart,
  Smartphone,
  Calendar,
  Check,
  Loader2,
  Edit2,
  X,
  AlertTriangle,
  Activity,
  History,
  Clock,
  XCircle
} from 'lucide-react';
import { toast } from 'react-hot-toast';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

// Sample ad groups data structure
const sampleAdGroups = {
  'search-1': [
    {
      id: 'ag1',
      name: 'Brand Keywords',
      status: 'Active',
      spend: 5200,
      impressions: 18000,
      clicks: 1200,
      ctr: 6.67,
      cpc: 4.33,
      conversions: 85,
      conversionRate: 7.08,
      costPerConversion: 61.18,
      revenue: 22100,
      roas: 4.25,
      keywords: [
        { id: 'kw1-1', text: 'glowytics brand', status: 'Active', matchType: 'Exact', qualityScore: 8, impressions: 4200, clicks: 320, ctr: 7.62, cpc: 4.10, conversions: 22, conversionRate: 6.88, costPerConversion: 59.64, revenue: 5800, roas: 4.42 },
        { id: 'kw1-2', text: 'glowytics analytics', status: 'Active', matchType: 'Phrase', qualityScore: 7, impressions: 3800, clicks: 280, ctr: 7.37, cpc: 4.25, conversions: 19, conversionRate: 6.79, costPerConversion: 62.63, revenue: 4900, roas: 4.12 },
        { id: 'kw1-3', text: 'glowytics platform', status: 'Active', matchType: 'Broad', qualityScore: 6, impressions: 3500, clicks: 230, ctr: 6.57, cpc: 4.40, conversions: 16, conversionRate: 6.96, costPerConversion: 63.25, revenue: 4200, roas: 4.15 },
        { id: 'kw1-4', text: 'glowytics software', status: 'Active', matchType: 'Exact', qualityScore: 8, impressions: 3300, clicks: 210, ctr: 6.36, cpc: 4.50, conversions: 15, conversionRate: 7.14, costPerConversion: 63.00, revenue: 3800, roas: 4.02 },
        { id: 'kw1-5', text: 'glowytics marketing', status: 'Active', matchType: 'Phrase', qualityScore: 7, impressions: 3200, clicks: 160, ctr: 5.00, cpc: 4.60, conversions: 13, conversionRate: 8.13, costPerConversion: 56.62, revenue: 3400, roas: 4.60 }
      ]
    },
    {
      id: 'ag2',
      name: 'Generic Keywords',
      status: 'Active',
      spend: 4800,
      impressions: 16500,
      clicks: 1100,
      ctr: 6.67,
      cpc: 4.36,
      conversions: 65,
      conversionRate: 5.91,
      costPerConversion: 73.85,
      revenue: 18200,
      roas: 3.79,
      keywords: [
        { id: 'kw2-1', text: 'marketing analytics', status: 'Active', matchType: 'Broad', qualityScore: 6, impressions: 3800, clicks: 250, ctr: 6.58, cpc: 4.20, conversions: 14, conversionRate: 5.60, costPerConversion: 75.00, revenue: 3900, roas: 3.71 },
        { id: 'kw2-2', text: 'analytics platform', status: 'Active', matchType: 'Phrase', qualityScore: 7, impressions: 3500, clicks: 230, ctr: 6.57, cpc: 4.30, conversions: 13, conversionRate: 5.65, costPerConversion: 76.15, revenue: 3700, roas: 3.75 },
        { id: 'kw2-3', text: 'marketing dashboard', status: 'Active', matchType: 'Exact', qualityScore: 8, impressions: 3200, clicks: 220, ctr: 6.88, cpc: 4.40, conversions: 13, conversionRate: 5.91, costPerConversion: 74.46, revenue: 3600, roas: 3.72 },
        { id: 'kw2-4', text: 'ads performance tracking', status: 'Active', matchType: 'Broad', qualityScore: 6, impressions: 3100, clicks: 210, ctr: 6.77, cpc: 4.50, conversions: 13, conversionRate: 6.19, costPerConversion: 72.69, revenue: 3500, roas: 3.70 },
        { id: 'kw2-5', text: 'marketing roi tool', status: 'Active', matchType: 'Phrase', qualityScore: 7, impressions: 2900, clicks: 190, ctr: 6.55, cpc: 4.60, conversions: 12, conversionRate: 6.32, costPerConversion: 72.83, revenue: 3500, roas: 4.01 }
      ]
    },
    {
      id: 'ag3',
      name: 'Competitor Keywords',
      status: 'Active',
      spend: 2500,
      impressions: 10500,
      clicks: 900,
      ctr: 8.57,
      cpc: 2.78,
      conversions: 30,
      conversionRate: 3.33,
      costPerConversion: 83.33,
      revenue: 12200,
      roas: 4.88,
      keywords: [
        { id: 'kw3-1', text: 'google analytics alternative', status: 'Active', matchType: 'Phrase', qualityScore: 7, impressions: 2400, clicks: 200, ctr: 8.33, cpc: 2.70, conversions: 7, conversionRate: 3.50, costPerConversion: 77.14, revenue: 2600, roas: 4.85 },
        { id: 'kw3-2', text: 'better than semrush', status: 'Active', matchType: 'Exact', qualityScore: 6, impressions: 2200, clicks: 190, ctr: 8.64, cpc: 2.75, conversions: 6, conversionRate: 3.16, costPerConversion: 87.08, revenue: 2500, roas: 4.79 },
        { id: 'kw3-3', text: 'hubspot vs', status: 'Active', matchType: 'Broad', qualityScore: 5, impressions: 2100, clicks: 180, ctr: 8.57, cpc: 2.80, conversions: 6, conversionRate: 3.33, costPerConversion: 84.00, revenue: 2400, roas: 4.76 },
        { id: 'kw3-4', text: 'mixpanel alternative', status: 'Active', matchType: 'Phrase', qualityScore: 7, impressions: 2000, clicks: 170, ctr: 8.50, cpc: 2.85, conversions: 6, conversionRate: 3.53, costPerConversion: 80.75, revenue: 2400, roas: 4.96 },
        { id: 'kw3-5', text: 'amplitude vs', status: 'Active', matchType: 'Broad', qualityScore: 5, impressions: 1800, clicks: 160, ctr: 8.89, cpc: 2.80, conversions: 5, conversionRate: 3.13, costPerConversion: 89.60, revenue: 2300, roas: 5.11 }
      ]
    }
  ],
  'search-2': [
    {
      id: 'ag4',
      name: 'Product Keywords',
      status: 'Active',
      spend: 3800,
      impressions: 14200,
      clicks: 980,
      ctr: 6.90,
      cpc: 3.88,
      conversions: 52,
      conversionRate: 5.31,
      costPerConversion: 73.08,
      revenue: 15600,
      roas: 4.11,
      keywords: [
        { id: 'kw4-1', text: 'analytics dashboard', status: 'Active', matchType: 'Exact', qualityScore: 8, impressions: 3200, clicks: 220, ctr: 6.88, cpc: 3.80, conversions: 12, conversionRate: 5.45, costPerConversion: 69.67, revenue: 3500, roas: 4.18 },
        { id: 'kw4-2', text: 'marketing analytics tool', status: 'Active', matchType: 'Phrase', qualityScore: 7, impressions: 3000, clicks: 210, ctr: 7.00, cpc: 3.85, conversions: 11, conversionRate: 5.24, costPerConversion: 73.55, revenue: 3300, roas: 4.08 },
        { id: 'kw4-3', text: 'ad performance tracker', status: 'Active', matchType: 'Broad', qualityScore: 6, impressions: 2800, clicks: 190, ctr: 6.79, cpc: 3.90, conversions: 10, conversionRate: 5.26, costPerConversion: 74.10, revenue: 3000, roas: 4.05 },
        { id: 'kw4-4', text: 'campaign analytics software', status: 'Active', matchType: 'Phrase', qualityScore: 7, impressions: 2700, clicks: 180, ctr: 6.67, cpc: 3.95, conversions: 10, conversionRate: 5.56, costPerConversion: 71.10, revenue: 2900, roas: 4.08 },
        { id: 'kw4-5', text: 'marketing performance dashboard', status: 'Active', matchType: 'Exact', qualityScore: 8, impressions: 2500, clicks: 180, ctr: 7.20, cpc: 3.90, conversions: 9, conversionRate: 5.00, costPerConversion: 78.00, revenue: 2900, roas: 4.14 }
      ]
    },
    {
      id: 'ag5',
      name: 'Category Keywords',
      status: 'Active',
      spend: 4200,
      impressions: 15800,
      clicks: 1050,
      ctr: 6.65,
      cpc: 4.00,
      conversions: 58,
      conversionRate: 5.52,
      costPerConversion: 72.41,
      revenue: 17400,
      roas: 4.14,
      keywords: [
        { id: 'kw5-1', text: 'marketing analytics', status: 'Active', matchType: 'Broad', qualityScore: 7, impressions: 3500, clicks: 230, ctr: 6.57, cpc: 3.95, conversions: 13, conversionRate: 5.65, costPerConversion: 69.92, revenue: 3800, roas: 4.18 },
        { id: 'kw5-2', text: 'digital marketing tools', status: 'Active', matchType: 'Phrase', qualityScore: 8, impressions: 3300, clicks: 220, ctr: 6.67, cpc: 4.00, conversions: 12, conversionRate: 5.45, costPerConversion: 73.33, revenue: 3600, roas: 4.09 },
        { id: 'kw5-3', text: 'ad campaign management', status: 'Active', matchType: 'Exact', qualityScore: 8, impressions: 3100, clicks: 210, ctr: 6.77, cpc: 4.05, conversions: 12, conversionRate: 5.71, costPerConversion: 70.88, revenue: 3500, roas: 4.12 },
        { id: 'kw5-4', text: 'marketing performance tracking', status: 'Active', matchType: 'Broad', qualityScore: 6, impressions: 3000, clicks: 200, ctr: 6.67, cpc: 4.10, conversions: 11, conversionRate: 5.50, costPerConversion: 74.55, revenue: 3300, roas: 4.02 },
        { id: 'kw5-5', text: 'advertising analytics', status: 'Active', matchType: 'Phrase', qualityScore: 7, impressions: 2900, clicks: 190, ctr: 6.55, cpc: 4.15, conversions: 10, conversionRate: 5.26, costPerConversion: 78.85, revenue: 3200, roas: 4.06 }
      ]
    }
  ],
  'search-3': [
    {
      id: 'ag6',
      name: 'Location Keywords',
      status: 'Active',
      spend: 2800,
      impressions: 11200,
      clicks: 780,
      ctr: 6.96,
      cpc: 3.59,
      conversions: 42,
      conversionRate: 5.38,
      costPerConversion: 66.67,
      revenue: 12600,
      roas: 4.50,
      keywords: [
        { id: 'kw6-1', text: 'marketing analytics istanbul', status: 'Active', matchType: 'Exact', qualityScore: 8, impressions: 2500, clicks: 170, ctr: 6.80, cpc: 3.55, conversions: 9, conversionRate: 5.29, costPerConversion: 67.06, revenue: 2700, roas: 4.47 },
        { id: 'kw6-2', text: 'ankara digital marketing tools', status: 'Active', matchType: 'Phrase', qualityScore: 7, impressions: 2300, clicks: 160, ctr: 6.96, cpc: 3.60, conversions: 9, conversionRate: 5.63, costPerConversion: 64.00, revenue: 2600, roas: 4.51 },
        { id: 'kw6-3', text: 'izmir ad campaign management', status: 'Active', matchType: 'Broad', qualityScore: 6, impressions: 2200, clicks: 150, ctr: 6.82, cpc: 3.65, conversions: 8, conversionRate: 5.33, costPerConversion: 68.44, revenue: 2500, roas: 4.56 },
        { id: 'kw6-4', text: 'antalya marketing analytics', status: 'Active', matchType: 'Exact', qualityScore: 8, impressions: 2100, clicks: 150, ctr: 7.14, cpc: 3.55, conversions: 8, conversionRate: 5.33, costPerConversion: 66.56, revenue: 2400, roas: 4.52 },
        { id: 'kw6-5', text: 'bursa advertising analytics', status: 'Active', matchType: 'Phrase', qualityScore: 7, impressions: 2100, clicks: 150, ctr: 7.14, cpc: 3.60, conversions: 8, conversionRate: 5.33, costPerConversion: 67.50, revenue: 2400, roas: 4.44 }
      ]
    }
  ],
  'search-4': [
    {
      id: 'ag7',
      name: 'Seasonal Keywords',
      status: 'Paused',
      spend: 1500,
      impressions: 8200,
      clicks: 420,
      ctr: 5.12,
      cpc: 3.57,
      conversions: 18,
      conversionRate: 4.29,
      costPerConversion: 83.33,
      revenue: 5400,
      roas: 3.60,
      keywords: [
        { id: 'kw7-1', text: 'summer marketing analytics', status: 'Paused', matchType: 'Broad', qualityScore: 6, impressions: 1800, clicks: 90, ctr: 5.00, cpc: 3.55, conversions: 4, conversionRate: 4.44, costPerConversion: 79.88, revenue: 1200, roas: 3.75 },
        { id: 'kw7-2', text: 'holiday season analytics', status: 'Paused', matchType: 'Phrase', qualityScore: 7, impressions: 1700, clicks: 85, ctr: 5.00, cpc: 3.60, conversions: 4, conversionRate: 4.71, costPerConversion: 76.50, revenue: 1100, roas: 3.60 },
        { id: 'kw7-3', text: 'black friday marketing tools', status: 'Paused', matchType: 'Exact', qualityScore: 8, impressions: 1600, clicks: 85, ctr: 5.31, cpc: 3.50, conversions: 4, conversionRate: 4.71, costPerConversion: 74.38, revenue: 1100, roas: 3.69 },
        { id: 'kw7-4', text: 'winter campaign analytics', status: 'Paused', matchType: 'Broad', qualityScore: 6, impressions: 1600, clicks: 80, ctr: 5.00, cpc: 3.60, conversions: 3, conversionRate: 3.75, costPerConversion: 96.00, revenue: 1000, roas: 3.47 },
        { id: 'kw7-5', text: 'seasonal marketing performance', status: 'Paused', matchType: 'Phrase', qualityScore: 7, impressions: 1500, clicks: 80, ctr: 5.33, cpc: 3.55, conversions: 3, conversionRate: 3.75, costPerConversion: 94.67, revenue: 1000, roas: 3.52 }
      ]
    }
  ],
  'search-5': [
    {
      id: 'ag8',
      name: 'Promotion Keywords',
      status: 'Active',
      spend: 3200,
      impressions: 12800,
      clicks: 890,
      ctr: 6.95,
      cpc: 3.60,
      conversions: 48,
      conversionRate: 5.39,
      costPerConversion: 66.67,
      revenue: 14400,
      roas: 4.50,
      keywords: [
        { id: 'kw8-1', text: 'marketing analytics discount', status: 'Active', matchType: 'Exact', qualityScore: 8, impressions: 2800, clicks: 190, ctr: 6.79, cpc: 3.55, conversions: 10, conversionRate: 5.26, costPerConversion: 67.45, revenue: 3100, roas: 4.59 },
        { id: 'kw8-2', text: 'analytics software promotion', status: 'Active', matchType: 'Phrase', qualityScore: 7, impressions: 2600, clicks: 180, ctr: 6.92, cpc: 3.60, conversions: 10, conversionRate: 5.56, costPerConversion: 64.80, revenue: 3000, roas: 4.63 },
        { id: 'kw8-3', text: 'special offer marketing tools', status: 'Active', matchType: 'Broad', qualityScore: 6, impressions: 2500, clicks: 175, ctr: 7.00, cpc: 3.65, conversions: 10, conversionRate: 5.71, costPerConversion: 63.88, revenue: 2900, roas: 4.54 },
        { id: 'kw8-4', text: 'marketing dashboard deal', status: 'Active', matchType: 'Exact', qualityScore: 8, impressions: 2500, clicks: 175, ctr: 7.00, cpc: 3.55, conversions: 9, conversionRate: 5.14, costPerConversion: 69.06, revenue: 2800, roas: 4.51 },
        { id: 'kw8-5', text: 'analytics platform offer', status: 'Active', matchType: 'Phrase', qualityScore: 7, impressions: 2400, clicks: 170, ctr: 7.08, cpc: 3.60, conversions: 9, conversionRate: 5.29, costPerConversion: 68.00, revenue: 2600, roas: 4.25 }
      ]
    }
  ],
  'search-6': [
    {
      id: 'ag9',
      name: 'Long-tail Keywords',
      status: 'Active',
      spend: 2900,
      impressions: 11600,
      clicks: 810,
      ctr: 6.98,
      cpc: 3.58,
      conversions: 44,
      conversionRate: 5.43,
      costPerConversion: 65.91,
      revenue: 13200,
      roas: 4.55,
      keywords: [
        { id: 'kw9-1', text: 'best marketing analytics platform for small business', status: 'Active', matchType: 'Broad', qualityScore: 7, impressions: 2500, clicks: 170, ctr: 6.80, cpc: 3.55, conversions: 9, conversionRate: 5.29, costPerConversion: 67.06, revenue: 2800, roas: 4.64 },
        { id: 'kw9-2', text: 'how to track marketing campaign performance effectively', status: 'Active', matchType: 'Phrase', qualityScore: 6, impressions: 2400, clicks: 165, ctr: 6.88, cpc: 3.60, conversions: 9, conversionRate: 5.45, costPerConversion: 66.00, revenue: 2700, roas: 4.55 },
        { id: 'kw9-3', text: 'affordable marketing analytics software for startups', status: 'Active', matchType: 'Exact', qualityScore: 8, impressions: 2300, clicks: 160, ctr: 6.96, cpc: 3.55, conversions: 9, conversionRate: 5.63, costPerConversion: 63.11, revenue: 2600, roas: 4.59 },
        { id: 'kw9-4', text: 'marketing roi tracking tool for multiple platforms', status: 'Active', matchType: 'Broad', qualityScore: 6, impressions: 2200, clicks: 160, ctr: 7.27, cpc: 3.60, conversions: 9, conversionRate: 5.63, costPerConversion: 64.00, revenue: 2600, roas: 4.51 },
        { id: 'kw9-5', text: 'all in one marketing analytics dashboard with reporting', status: 'Active', matchType: 'Phrase', qualityScore: 7, impressions: 2200, clicks: 155, ctr: 7.05, cpc: 3.55, conversions: 8, conversionRate: 5.16, costPerConversion: 68.78, revenue: 2500, roas: 4.54 }
      ]
    }
  ],
  'search-7': [
    {
      id: 'ag10',
      name: 'Dynamic Keywords',
      status: 'Active',
      spend: 3500,
      impressions: 13500,
      clicks: 940,
      ctr: 6.96,
      cpc: 3.72,
      conversions: 51,
      conversionRate: 5.43,
      costPerConversion: 68.63,
      revenue: 15300,
      roas: 4.37,
      keywords: [
        { id: 'kw10-1', text: '{marketing analytics} software', status: 'Active', matchType: 'Dynamic', qualityScore: 7, impressions: 2900, clicks: 200, ctr: 6.90, cpc: 3.70, conversions: 11, conversionRate: 5.50, costPerConversion: 67.27, revenue: 3300, roas: 4.46 },
        { id: 'kw10-2', text: '{digital marketing} dashboard', status: 'Active', matchType: 'Dynamic', qualityScore: 7, impressions: 2800, clicks: 195, ctr: 6.96, cpc: 3.75, conversions: 11, conversionRate: 5.64, costPerConversion: 66.48, revenue: 3200, roas: 4.38 },
        { id: 'kw10-3', text: '{campaign performance} tracking', status: 'Active', matchType: 'Dynamic', qualityScore: 6, impressions: 2700, clicks: 185, ctr: 6.85, cpc: 3.70, conversions: 10, conversionRate: 5.41, costPerConversion: 68.45, revenue: 3000, roas: 4.38 },
        { id: 'kw10-4', text: '{advertising analytics} platform', status: 'Active', matchType: 'Dynamic', qualityScore: 7, impressions: 2600, clicks: 180, ctr: 6.92, cpc: 3.75, conversions: 10, conversionRate: 5.56, costPerConversion: 67.50, revenue: 2900, roas: 4.30 },
        { id: 'kw10-5', text: '{marketing roi} calculator', status: 'Active', matchType: 'Dynamic', qualityScore: 8, impressions: 2500, clicks: 180, ctr: 7.20, cpc: 3.70, conversions: 9, conversionRate: 5.00, costPerConversion: 74.00, revenue: 2900, roas: 4.35 }
      ]
    }
  ]
};

// Sample chart data
const chartData = {
  labels: ['1 Jan', '2 Jan', '3 Jan', '4 Jan', '5 Jan', '6 Jan', '7 Jan'],
  datasets: [
    {
      label: 'Spend',
      data: [300, 450, 320, 500, 350, 200, 400],
      borderColor: 'rgb(59, 130, 246)',
      backgroundColor: 'rgba(59, 130, 246, 0.1)',
      fill: true,
      tension: 0.4,
      yAxisID: 'y',
    },
    {
      label: 'Revenue',
      data: [500, 300, 400, 600, 450, 350, 550],
      borderColor: 'rgb(16, 185, 129)',
      backgroundColor: 'rgba(16, 185, 129, 0.1)',
      fill: true,
      tension: 0.4,
      yAxisID: 'y',
    }
  ]
};

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    y: {
      type: 'linear',
      display: true,
      position: 'left',
      beginAtZero: true,
      grid: {
        color: 'rgba(0, 0, 0, 0.05)',
      },
      ticks: {
        callback: (value) => {
          if (value >= 1000000) {
            return `₺${(value / 1000000).toFixed(1)}M`;
          } else if (value >= 1000) {
            return `₺${(value / 1000).toFixed(1)}K`;
          }
          return `₺${value}`;
        },
        font: {
          size: 11
        }
      },
      title: {
        display: true,
        text: 'Cost (₺)',
        color: '#3B82F6',
        font: {
          size: 12,
          weight: '500'
        }
      }
    },
    y1: {
      type: 'linear',
      display: true,
      position: 'right',
      beginAtZero: true,
      grid: {
        drawOnChartArea: false,
      },
      ticks: {
        callback: (value) => {
          if (value >= 1000000) {
            return `${(value / 1000000).toFixed(1)}M`;
          } else if (value >= 1000) {
            return `${(value / 1000).toFixed(1)}K`;
          }
          return value.toString();
        },
        font: {
          size: 11
        }
      },
      title: {
        display: true,
        text: 'Installs',
        color: '#10B981',
        font: {
          size: 12,
          weight: '500'
        }
      }
    },
    x: {
      grid: {
        display: false
      },
      ticks: {
        maxTicksLimit: 10,
        font: {
          size: 11
        }
      }
    }
  },
  plugins: {
    legend: {
      position: 'top',
      align: 'end',
      labels: {
        boxWidth: 10,
        usePointStyle: true,
        pointStyle: 'circle'
      }
    },
    tooltip: {
      callbacks: {
        label: function(context) {
          let label = context.dataset.label || '';
          if (label) {
            label += ': ';
          }
          if (context.parsed.y !== null) {
            if (context.dataset.label === 'Installs') {
              label += context.parsed.y.toLocaleString('tr-TR');
            } else {
              label += `₺${context.parsed.y.toLocaleString('tr-TR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
            }
          }
          return label;
        }
      }
    }
  },
  interaction: {
    intersect: false,
    mode: 'index',
  }
};

export default function AppCampaigns() {
  const { selectedBrand } = useAuth();
  const { getSelectedAccountId } = useAccounts();
  const selectedAccountId = getSelectedAccountId('GOOGLE_ADS');

  const [liveDataMap, setLiveDataMap] = useState({});
  const [isLoadingLive, setIsLoadingLive] = useState(false);
  const [openStatusDropdown, setOpenStatusDropdown] = useState(null);
  const [editBudget, setEditBudget] = useState(null);
  const [updatingId, setUpdatingId] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState(null);

  // Change History state
  const [showChangeHistory, setShowChangeHistory] = useState(false);
  const [changeHistoryData, setChangeHistoryData] = useState([]);
  const [changeHistoryTotal, setChangeHistoryTotal] = useState(0);
  const [changeHistoryLoading, setChangeHistoryLoading] = useState(false);
  const [changeHistoryFilter, setChangeHistoryFilter] = useState('all');

  const [isLoading, setIsLoading] = useState(false);
  const [dateRange, setDateRange] = useState('last30');
  const [gaAccountFilter, setGaAccountFilter] = useState('all');
  const [gaAccounts, setGaAccounts] = useState([]);
  const [keywordData, setKeywordData] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [expandedCampaigns, setExpandedCampaigns] = useState(new Set());
  const [expandedAdGroups, setExpandedAdGroups] = useState(new Set());
  // Sıralama için state değişkenleri
  const [sortField, setSortField] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');
  // Chart verisi için state
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: 'Spend',
        data: [],
        borderColor: 'rgb(59, 130, 246)',
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        fill: true,
        tension: 0.4,
        yAxisID: 'y',
      },
      {
        label: 'Revenue',
        data: [],
        borderColor: 'rgb(16, 185, 129)',
        backgroundColor: 'rgba(16, 185, 129, 0.1)',
        fill: true,
        tension: 0.4,
        yAxisID: 'y',
      }
    ]
  });

  // Add missing state variables
  const [trendData, setTrendData] = useState([]);
  const [isLoadingTrend, setIsLoadingTrend] = useState(false);

  // Update the state to include the new filter option
  const [selectedDateRange, setSelectedDateRange] = useState('7days');

  // State kısmına dataLoading ekleyelim
  const [dataLoading, setDataLoading] = useState(true);
  
  // App Campaign specific state
  const [appCampaignsData, setAppCampaignsData] = useState(null);
  const [isLoadingAppCampaigns, setIsLoadingAppCampaigns] = useState(false);

  // UI state
  const [isDateDropdownOpen, setIsDateDropdownOpen] = useState(false);
  const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);
  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(null);

  // Brand-specific dummy fallback id
  const DUMMY_BRAND_ID = '9ad536a0-dbdf-4935-8730-f2c2029c6d52';
  const DEMO_BRAND_ID_SC = '2b08baa8-dd8e-4b5c-93cd-dd38b9b3718a';
  const TARGET_BRAND_ID_ADJUST = 'ec9873c2-0edb-44eb-ac6f-2670c8e56dc4';

  // Build dummy App Campaigns dataset (campaigns + dailyTrend + totals)
  const buildDummyAppData = () => {
    const campaigns = [];
    const dailyTrend = [];
    const today = new Date();
    const days = 14;
    for (let i = 1; i <= 8; i++) {
      const impressions = 80000 + i * 4500;
      const clicks = 12000 + i * 600;
      const installs = 2500 + i * 120;
      const cost = 18000 + i * 1500;
      const ctr = impressions > 0 ? (clicks / impressions) * 100 : 0;
      const cpc = clicks > 0 ? (cost / clicks) : 0;
      const convRate = clicks > 0 ? (installs / clicks) * 100 : 0;
      // GA4 + Adjust synthetic
      const ga4Sessions = Math.round(clicks * 1.15);
      const ga4Purchases = Math.round(installs * 0.18);
      const ga4Revenue = Math.round(ga4Purchases * 900);
      const adjustSessions = Math.round(ga4Sessions * 0.8);
      const adjustInstalls = Math.round(installs * 0.95);
      const adjustPurchases = Math.round(ga4Purchases * 0.85);
      const adjustRevenue = Math.round(ga4Revenue * 0.9);
      const adGroups = [
        { id: `AG-${i}-1`, name: 'Ad Group A', status: 'ENABLED', spend: cost * 0.55, impressions: Math.round(impressions * 0.55), clicks: Math.round(clicks * 0.55), conversions: Math.round(installs * 0.55) },
        { id: `AG-${i}-2`, name: 'Ad Group B', status: 'ENABLED', spend: cost * 0.45, impressions: Math.round(impressions * 0.45), clicks: Math.round(clicks * 0.45), conversions: Math.round(installs * 0.45) },
      ];
      campaigns.push({
        id: `APP-C-${i}`,
        name: `App Campaign ${i}`,
        status: 'ENABLED',
        budget: 20000 + i * 1000,
        cost,
        spend: cost,
        impressions,
        clicks,
        conversions: installs,
        ctr,
        cpc,
        conversionRate: convRate,
        ga4_sessions: ga4Sessions,
        ga4_purchases: ga4Purchases,
        ga4_total_revenue: ga4Revenue,
        adjust_sessions: adjustSessions,
        adjust_installs: adjustInstalls,
        adjust_purchase_events: adjustPurchases,
        adjust_all_revenue: adjustRevenue,
        adGroups,
      });
    }
    for (let d = 0; d < days; d++) {
      const date = new Date(today);
      date.setDate(today.getDate() - (days - 1 - d));
      const cost = 15000 + d * 900;
      const conversions = 2000 + d * 60;
      dailyTrend.push({ date: date.toISOString().split('T')[0], cost, conversions });
    }
    const totals = campaigns.reduce((acc, c) => {
      acc.impressions += Number(c.impressions || 0);
      acc.clicks += Number(c.clicks || 0);
      acc.cost += Number(c.cost || 0);
      acc.conversions += Number(c.conversions || 0);
      return acc;
    }, { impressions: 0, clicks: 0, cost: 0, conversions: 0 });
    const totalMetrics = {
      impressions: totals.impressions,
      clicks: totals.clicks,
      cost: totals.cost,
      conversions: totals.conversions,
      ctr: totals.impressions > 0 ? (totals.clicks / totals.impressions) * 100 : 0,
      cpc: totals.clicks > 0 ? (totals.cost / totals.clicks) : 0,
      conversionRate: totals.clicks > 0 ? (totals.conversions / totals.clicks) * 100 : 0,
      costPerConversion: totals.conversions > 0 ? (totals.cost / totals.conversions) : 0,
    };
    return { campaigns, dailyTrend, totalMetrics };
  };

  // Kampanya genişletme/daraltma işlevi
  const toggleCampaign = (campaignId, e) => {
    e.stopPropagation();
    setExpandedCampaigns(prev => {
      const newSet = new Set(prev);
      if (newSet.has(campaignId)) {
        newSet.delete(campaignId);
      } else {
        newSet.add(campaignId);
      }
      return newSet;
    });
  };

  // Reklam grubu genişletme/daraltma işlevi
  const toggleAdGroup = (adGroupId, e) => {
    e.stopPropagation();
    setExpandedAdGroups(prev => {
      const newSet = new Set(prev);
      if (newSet.has(adGroupId)) {
        newSet.delete(adGroupId);
      } else {
        newSet.add(adGroupId);
      }
      return newSet;
    });
  };

  // Sıralama işlevi
  const handleSort = (field) => {
    if (sortField === field) {
      // Aynı alan üzerine tıklandığında sıralama yönünü değiştir
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      // Yeni bir alan seçildiğinde, varsayılan olarak azalan sıralama yap
      setSortField(field);
      setSortDirection(field === 'budget' ? 'desc' : 'asc');
    }
  };

  // Anahtar kelimeleri sırala
  const sortKeywords = (keywords, field, direction) => {
    if (!field) return keywords;

    return [...keywords].sort((a, b) => {
      // Sayısal değerler için sıralama
      if (['spend', 'budget', 'impressions', 'clicks', 'ctr', 'cpc', 'conversions', 'conversionRate', 'costPerConversion', 'conversionValue', 'roas'].includes(field)) {
        // Sayısal değerleri güvenli bir şekilde al
        const aValue = parseFloat(a[field]) || 0;
        const bValue = parseFloat(b[field]) || 0;
        
        return direction === 'asc' 
          ? aValue - bValue 
          : bValue - aValue;
      }
      
      // Metin değerleri için sıralama (anahtar kelime metni, durum vb.)
      if (['text', 'status'].includes(field)) {
        const aValue = String(a[field] || '').toLowerCase();
        const bValue = String(b[field] || '').toLowerCase();
        
        if (direction === 'asc') {
          return aValue.localeCompare(bValue);
        } else {
          return bValue.localeCompare(aValue);
        }
      }
      
      // Varsayılan olarak budget'a göre azalan sıralama
      return b.budget - a.budget;
    });
  };

  // Function to organize keyword data into campaigns and ad groups
  const organizeKeywordData = (data) => {
    if (!data || data.length === 0) {
      console.log('No keyword data available');
      return { campaigns: [] };
    }

    console.log(`Organizing ${data.length} keyword records`);

    // Kampanya ve reklam grupları için map'ler oluştur
    const campaignMap = new Map();
    const adGroupMap = new Map();
    
    // Anahtar kelimeleri birleştirmek için bir map oluştur
    const keywordMap = new Map();

    // Önce tüm kampanya ve reklam gruplarını oluştur
    data.forEach(item => {
      const campaignId = item.campaign_id;
      const adGroupId = item.ad_group_id;
      const keywordId = item.keyword_id;
      const keywordText = item.keyword_text?.toLowerCase() || '';

      // Kampanyayı ekle
      if (!campaignMap.has(campaignId)) {
        campaignMap.set(campaignId, {
          id: campaignId,
          name: item.campaign_name || 'Unknown Campaign',
          status: item.campaign_status || 'Unknown',
          budget: parseFloat(item.campaign_budget || 0),
          spend: 0, // Reklam gruplarından hesaplanacak
          impressions: 0, // Reklam gruplarından hesaplanacak
          clicks: 0, // Reklam gruplarından hesaplanacak
          conversions: 0, // Reklam gruplarından hesaplanacak
          conversionValue: 0, // Reklam gruplarından hesaplanacak
          adGroups: [],
          expanded: true
        });
      }

      // Reklam grubunu ekle
      if (!adGroupMap.has(adGroupId)) {
        adGroupMap.set(adGroupId, {
          id: adGroupId,
          name: item.ad_group_name || 'Unknown Ad Group',
          status: item.ad_group_status || 'Unknown',
          campaignId: campaignId,
          spend: 0, // Anahtar kelimelerden hesaplanacak
          impressions: 0, // Anahtar kelimelerden hesaplanacak
          clicks: 0, // Anahtar kelimelerden hesaplanacak
          conversions: 0, // Anahtar kelimelerden hesaplanacak
          conversionValue: 0, // Anahtar kelimelerden hesaplanacak
          keywords: [],
          expanded: false
        });
      }

      // Anahtar kelime için benzersiz bir kimlik oluştur (reklam grubu + anahtar kelime metni)
      const uniqueKeywordId = `${adGroupId}_${keywordText}`;
      
      // Anahtar kelimeyi ekle veya güncelle
      if (!keywordMap.has(uniqueKeywordId)) {
        keywordMap.set(uniqueKeywordId, {
          id: keywordId,
          text: keywordText,
          status: item.keyword_status || 'Unknown',
          adGroupId: adGroupId,
          matchType: item.keyword_match_type || 'Unknown',
          spend: parseFloat(item.cost || 0),
          impressions: parseInt(item.impressions || 0, 10),
          clicks: parseInt(item.clicks || 0, 10),
          conversions: parseInt(item.conversions || 0, 10),
          conversionValue: parseFloat(item.conversion_value || 0),
          matchTypes: [item.keyword_match_type || 'Unknown']
        });
      } else {
        // Mevcut anahtar kelimeyi güncelle (metrikleri topla)
        const existingKeyword = keywordMap.get(uniqueKeywordId);
        existingKeyword.spend += parseFloat(item.cost || 0);
        existingKeyword.impressions += parseInt(item.impressions || 0, 10);
        existingKeyword.clicks += parseInt(item.clicks || 0, 10);
        existingKeyword.conversions += parseInt(item.conversions || 0, 10);
        existingKeyword.conversionValue += parseFloat(item.conversion_value || 0);
        
        // Eşleşme türünü ekle (eğer zaten yoksa)
        if (item.keyword_match_type && !existingKeyword.matchTypes.includes(item.keyword_match_type)) {
          existingKeyword.matchTypes.push(item.keyword_match_type);
        }
      }
    });

    // Anahtar kelimeleri reklam gruplarına ekle ve metrikleri hesapla
    adGroupMap.forEach(adGroup => {
      // Anahtar kelimeleri reklam gruplarına ekle
      const adGroupKeywords = Array.from(keywordMap.values())
        .filter(keyword => keyword.adGroupId === adGroup.id);
      
      adGroup.keywords = adGroupKeywords;
      
      // Anahtar kelimelerden reklam grubu metriklerini hesapla
      adGroupKeywords.forEach(keyword => {
        adGroup.spend += keyword.spend || 0;
        adGroup.impressions += keyword.impressions || 0;
        adGroup.clicks += keyword.clicks || 0;
        adGroup.conversions += keyword.conversions || 0;
        adGroup.conversionValue += keyword.conversionValue || 0;
      });
      
      // CTR, CPC, dönüşüm oranı vb. hesapla
      adGroup.ctr = adGroup.impressions > 0 ? (adGroup.clicks / adGroup.impressions) * 100 : 0;
      adGroup.cpc = adGroup.clicks > 0 ? adGroup.spend / adGroup.clicks : 0;
      adGroup.conversionRate = adGroup.clicks > 0 ? (adGroup.conversions / adGroup.clicks) * 100 : 0;
      adGroup.costPerConversion = adGroup.conversions > 0 ? adGroup.spend / adGroup.conversions : 0;
      adGroup.roas = adGroup.spend > 0 ? adGroup.conversionValue / adGroup.spend : 0;
      
      // Reklam grubunu ilgili kampanyaya ekle
      const campaign = campaignMap.get(adGroup.campaignId);
      if (campaign) {
        campaign.adGroups.push(adGroup);
        
        // Reklam grubu metriklerini kampanya metriklerine ekle
        campaign.spend += adGroup.spend || 0;
        campaign.impressions += adGroup.impressions || 0;
        campaign.clicks += adGroup.clicks || 0;
        campaign.conversions += adGroup.conversions || 0;
        campaign.conversionValue += adGroup.conversionValue || 0;
      }
    });

    // Kampanya metriklerini hesapla
    campaignMap.forEach(campaign => {
      // CTR, CPC, dönüşüm oranı vb. hesapla
      campaign.ctr = campaign.impressions > 0 ? (campaign.clicks / campaign.impressions) * 100 : 0;
      campaign.cpc = campaign.clicks > 0 ? campaign.spend / campaign.clicks : 0;
      campaign.conversionRate = campaign.clicks > 0 ? (campaign.conversions / campaign.clicks) * 100 : 0;
      campaign.costPerConversion = campaign.conversions > 0 ? campaign.spend / campaign.conversions : 0;
      campaign.roas = campaign.spend > 0 ? campaign.conversionValue / campaign.spend : 0;
      
      // Kampanya gelirini conversionValue olarak ayarla
      campaign.revenue = campaign.conversionValue;
    });

    // Kampanyaları bir diziye dönüştür
    const campaigns = Array.from(campaignMap.values());
    
    console.log(`Organized ${campaigns.length} campaigns with ${adGroupMap.size} ad groups and ${keywordMap.size} unique keywords`);
    
    return { campaigns };
  };

  // Calculate summary metrics from campaigns
  const calculateSummaryMetrics = (campaigns) => {
    if (!campaigns || campaigns.length === 0) {
      return {
        cpc: 0,
        conversionRate: 0,
        cost: 0,
        roas: 0,
        revenue: 0,
        clicks: 0,
        conversions: 0,
        ga4Revenue: 0,
        ga4Roas: 0,
        ga4Conversions: 0,
        ga4ConversionRate: 0,
        sessions: 0,
        adjustSessions: 0,
        ga4Transactions: 0,
        adjustInstalls: 0,
        adjustPurchaseEvents: 0,
        adjustAllRevenue: 0
      };
    }

    let totalClicks = 0;
    let totalCost = 0;
    let totalConversions = 0;
    let totalRevenue = 0;
    let totalGa4Revenue = 0;
    let totalGa4Conversions = 0;
    let totalSessions = 0;
    let totalAdjustSessions = 0;

    campaigns.forEach(campaign => {
      totalClicks += campaign.clicks || 0;
      totalCost += campaign.spend || 0;
      totalConversions += campaign.conversions || 0;
      totalRevenue += campaign.revenue || 0;
      totalGa4Revenue += campaign.ga4_total_revenue || 0;
      totalGa4Conversions += campaign.ga4_purchases || 0;
      totalSessions += campaign.ga4_sessions || 0;
      totalAdjustSessions += campaign.adjust_sessions || campaign.adjustSessions || 0;
    });

    const avgCpc = totalClicks > 0 ? totalCost / totalClicks : 0;
    const conversionRate = totalClicks > 0 ? (totalConversions / totalClicks) * 100 : 0;
    const roas = totalCost > 0 ? totalRevenue / totalCost : 0;
    const ga4Roas = totalCost > 0 ? totalGa4Revenue / totalCost : 0;
    const ga4ConversionRate = totalSessions > 0 ? totalGa4Conversions / totalSessions : 0;

    return {
      cpc: avgCpc,
      conversionRate,
      cost: totalCost,
      roas,
      revenue: totalRevenue,
      clicks: totalClicks,
      conversions: totalConversions,
      ga4Revenue: totalGa4Revenue,
      ga4Roas,
      ga4Conversions: totalGa4Conversions,
      ga4ConversionRate,
      sessions: totalSessions,
      adjustSessions: totalAdjustSessions,
      ga4Transactions: 0,
      adjustInstalls: 0,
      adjustPurchaseEvents: 0,
      adjustAllRevenue: 0
    };
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setDataLoading(true);
        await fetchAppCampaignData();
        const brandId = localStorage.getItem('currentBrandId');
        if (brandId === DUMMY_BRAND_ID || brandId === DEMO_BRAND_ID_SC) {
          setAppCampaignsData(prev => {
            if (prev && Array.isArray(prev.campaigns) && prev.campaigns.length > 0) return prev;
            return buildDummyAppData();
          });
        }
      } catch (error) {
        console.error('Error:', error);
      } finally {
        setDataLoading(false);
      }
    };

    fetchData();
  }, [dateRange, selectedAccountId, gaAccountFilter]);

  useEffect(() => {
    const brandId = localStorage.getItem('currentBrandId');
    if (!brandId) return;
    fetch('https://api.glowytics.com/api/auth/connections', {
      credentials: 'include',
      headers: { 'X-Brand-ID': brandId }
    })
      .then(r => r.json())
      .then(data => {
        const list = Array.isArray(data) ? data : (data.connections || []);
        const ga = list.filter(c => c.platform === 'GOOGLE_ADS' && c.status === 'ACTIVE');
        setGaAccounts(ga);
      })
      .catch(() => {});
  }, []);

  // Re-fetch when custom range changes
  useEffect(() => {
    if (dateRange === 'custom' && customStartDate && customEndDate) {
      fetchAppCampaignData();
      fetchKeywordData();
    }
  }, [customStartDate, customEndDate, dateRange, gaAccountFilter]);

  // Process keyword data when it changes
  useEffect(() => {
    if (keywordData && Array.isArray(keywordData) && keywordData.length > 0) {
      console.log('Processing keyword data...');
      try {
        const { campaigns: fetchedCampaigns } = organizeKeywordData(keywordData);
        
        // Update state with fetched data
        setCampaigns(fetchedCampaigns);
        
        // Başlangıçta tüm kampanyalar kapalı olsun
        setExpandedCampaigns(new Set());
        
        // Log the organized data
        console.log('Organized campaigns:', fetchedCampaigns);
        
        // Remove the call to generateTrendDataFromKeywords that's causing errors
        // generateTrendDataFromKeywords();
        
        setIsLoading(false);
      } catch (error) {
        console.error('Error processing keyword data:', error);
        // Remove the toast error message
        // toast.error('Error processing campaign data');
        setIsLoading(false);
      }
    }
  }, [keywordData]);

  // Function to fetch App Campaign data from the backend
  const fetchAppCampaignData = async () => {
    try {
      setIsLoadingAppCampaigns(true);
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) {
        console.error('No brand ID found in localStorage');
        return;
      }

      console.log(`Fetching app campaign data for brand ID: ${brandId} with date range: ${dateRange}`);
      const range = calculateDateRange(dateRange);
      const qs = new URLSearchParams();
      qs.set('dateRange', dateRange);
      if (range?.startDate && range?.endDate) {
        qs.set('startDate', range.startDate);
        qs.set('endDate', range.endDate);
      }

      if (gaAccountFilter !== 'all') qs.set('accountId', gaAccountFilter);

      // DEMO/DUMMY short-circuit: always fill dummy for specified brands
      if (brandId === DUMMY_BRAND_ID || brandId === DEMO_BRAND_ID_SC || brandId === TARGET_BRAND_ID_ADJUST) {
        const dummy = buildDummyAppData();
        setAppCampaignsData(dummy);
        updateAppCampaignChart(dummy.dailyTrend);
        return;
      }

      const response = await fetch(`https://api.glowytics.com/api/google-ads/app-campaign-performance?${qs.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include',
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('App Campaign API Error:', errorData);
        throw new Error(`Failed to fetch app campaign data: ${errorData.message || response.statusText}`);
      }

      let data = await response.json();
      // Brand-specific dummy fallback when API returns empty
      if ((brandId === DUMMY_BRAND_ID || brandId === TARGET_BRAND_ID_ADJUST) && (!data || (!Array.isArray(data.campaigns) || data.campaigns.length === 0))) {
        data = buildDummyAppData();
      }
      
      console.log('App campaign data fetched successfully:', data);
      
      // Log daily trend data specifically for debugging
      if (data && data.dailyTrend) {
        console.log('Daily trend data from API:', data.dailyTrend);
        if (data.dailyTrend.length > 0) {
          console.log('Sample daily trend item:', data.dailyTrend[0]);
        }
      }
      
      // Debug campaign names specifically
      if (data && data.campaigns) {
        console.log('App campaigns count:', data.campaigns.length);
        data.campaigns.forEach((campaign, index) => {
          console.log(`Campaign ${index + 1}:`, {
            id: campaign.id,
            name: campaign.name || campaign.campaign_name,
            status: campaign.status,
            cost: campaign.cost || campaign.spend,
            impressions: campaign.impressions,
            clicks: campaign.clicks,
            conversions: campaign.conversions
          });
        });
      }
      
      // Save app campaigns data to state
      setAppCampaignsData(data);
      
      // Update chart with daily trend data if available
      if (data && data.dailyTrend && data.dailyTrend.length > 0) {
        updateAppCampaignChart(data.dailyTrend);
      } else {
        // Clear chart if no data
        console.log('No app campaign data found - clearing chart');
        // If dummy is used, fill chart as well
        if (brandId === DUMMY_BRAND_ID) {
          const dummy = buildDummyAppData();
          updateAppCampaignChart(dummy.dailyTrend);
        } else {
          updateAppCampaignChart([]);
        }
      }
      
    } catch (error) {
      console.error('Error fetching app campaign data:', error);
      // Set empty data on error
      setAppCampaignsData({
        campaigns: [],
        adGroups: [],
        dailyTrend: [],
        totalMetrics: {
          impressions: 0,
          clicks: 0,
          cost: 0,
          conversions: 0,
          ctr: 0,
          cpc: 0,
          conversionRate: 0,
          costPerConversion: 0
        }
      });
      
      // Clear chart on error
      updateAppCampaignChart([]);
    } finally {
      setIsLoadingAppCampaigns(false);
    }
  };

  // Function to fetch keyword data from the database
  const fetchKeywordData = async () => {
    try {
      setIsLoading(true);
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) {
        console.error('No brand ID found in localStorage');
        setIsLoading(false);
        return;
      }

      console.log('Fetching keyword data for brand ID:', brandId);
      
      // Calculate date range based on selected filter
      const range = calculateDateRange(dateRange);
      const qs = new URLSearchParams();
      qs.set('dateRange', dateRange);
      if (range?.startDate && range?.endDate) {
        qs.set('startDate', range.startDate);
        qs.set('endDate', range.endDate);
      }
      if (gaAccountFilter !== 'all') qs.set('accountId', gaAccountFilter);

      // Update the API URL to match the backend URL structure
      const response = await fetch(`https://api.glowytics.com/api/google-ads/keyword-full-performance?${qs.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId,
        },
        credentials: 'include',
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('API Error:', errorData);
        throw new Error(`Failed to fetch keyword data: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      console.log('Keyword data fetched successfully from google_ads_keyword_full_performance view:', data);
      
      // Log the first few records to inspect the structure
      if (data && data.length > 0) {
        console.log('Sample data (first 3 records):', data.slice(0, 3));
        
        // Group data by date and calculate total cost for each date
        // Data is already filtered by date range from API
        groupKeywordDataByDate(data);
      } else {
        console.log('No data returned from API');
      }
      
      setKeywordData(data);
      
      // Try-catch block for fetchPerformanceTrend to prevent errors
      try {
        // Ayrıca son 30 günlük trend verilerini çekelim
        await fetchPerformanceTrend();
      } catch (error) {
        console.error("Error in fetchPerformanceTrend:", error);
        // Don't show error toast
      }
      
      setIsLoading(false); // Make sure to set loading to false here
    } catch (error) {
      console.error('Error fetching keyword data:', error);
      // Remove toast error message
      // toast.error(`Failed to fetch keyword data: ${error.message}`);
      setIsLoading(false);
    }
  };
  
  // Update the calculateDateRange function to handle the "This Month" filter
  const calculateDateRange = (selectedRange) => {
    const now = new Date();
    let startDate, endDate;

    switch (selectedRange) {
      case 'today':
        startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
        break;
      case 'yesterday':
        startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 23, 59, 59);
        break;
      case '7days':
        startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);
        endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 23, 59, 59);
        break;
      case '30days':
        // Fix: Correctly set to 30 days ago instead of 7
        
        startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30);
        endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
        console.log(`30 days range: ${startDate.toISOString()} to ${endDate.toISOString()}`);
        break;
      case 'thisMonth':
        // First day of current month
        startDate = new Date(now.getFullYear(), now.getMonth(), 1);
        // Current day
        endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
        break;
      case 'lastMonth':
        // First day of last month
        startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        // Last day of last month
        endDate = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59);
        break;
      default:
        startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);
        endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 23, 59, 59);
    }

    return {
      startDate: startDate.toISOString().split('T')[0],
      endDate: endDate.toISOString().split('T')[0]
    };
  };
  
  // Helper function to filter data by date range
  const filterDataByDateRange = (data, dateRange) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [];
    }
    
    const startDate = new Date(dateRange.startDate);
    const endDate = new Date(dateRange.endDate);
    
    // Set time to end of day for end date for inclusive comparison
    endDate.setHours(23, 59, 59, 999);
    
    return data.filter(item => {
      if (!item.date) return false;
      
      const itemDate = new Date(item.date);
      return itemDate >= startDate && itemDate <= endDate;
    });
  };
  
  // New function to group keyword data by date and calculate total cost
  const groupKeywordDataByDate = (keywordData) => {
    console.log("========== STARTING DAILY COST CALCULATION ==========");
    console.log("Input data count:", keywordData.length);
    
    // Log the structure of the first few records to understand the data format
    if (keywordData.length > 0) {
      // Log the keys of the first record to see what fields are available
      console.log("First record keys:", Object.keys(keywordData[0]));
      
      // Log the complete first record for inspection
      console.log("First record:", keywordData[0]);
      
      // Check if cost is in a different field
      if (keywordData[0].cost !== undefined) {
        console.log("Found 'cost' field instead of 'cost_micros'");
      }
      
      // Check for nested fields that might contain cost data
      for (const key in keywordData[0]) {
        const value = keywordData[0][key];
        if (value && typeof value === 'object') {
          console.log(`Checking nested object in field '${key}':`, value);
          
          // Check if this nested object has cost-related fields
          if (value.cost !== undefined || value.cost_micros !== undefined) {
            console.log(`Found cost data in nested field '${key}'`);
          }
        }
      }
    }
    
    // Create a map to store costs by date
    const costByDate = new Map();
    let processedRecords = 0;
    let recordsWithDate = 0;
    let recordsWithCost = 0;
    
    // Process each keyword
    keywordData.forEach(keyword => {
      processedRecords++;
      
      // Check if the keyword has a date field
      if (keyword.date) {
        recordsWithDate++;
        
        // Check for cost field (not cost_micros)
        if (keyword.cost !== undefined) {
          recordsWithCost++;
          const date = keyword.date;
          // Assuming cost is already in the correct format (not micros)
          const cost = parseFloat(keyword.cost);
          
          if (costByDate.has(date)) {
            costByDate.set(date, costByDate.get(date) + cost);
          } else {
            costByDate.set(date, cost);
          }
        }
      }
    });
    
    console.log("Processing stats:");
    console.log("- Total records processed:", processedRecords);
    console.log("- Records with date field:", recordsWithDate);
    console.log("- Records with cost field:", recordsWithCost);
    
    // Convert map to array of objects sorted by date
    const dailyCostArray = Array.from(costByDate.entries())
      .map(([date, cost]) => ({ date, cost }))
      .sort((a, b) => new Date(a.date) - new Date(b.date));
    
    console.log("========== DAILY COST DATA (GROUPED BY DATE) ==========");
    console.log(dailyCostArray);
    
    // Also log in table format for better readability
    console.log("========== DAILY COST DATA (TABLE FORMAT) ==========");
    console.table(dailyCostArray);
    
    console.log("Total unique dates:", dailyCostArray.length);
    console.log("Date range:", 
      dailyCostArray.length > 0 ? 
      `${dailyCostArray[0].date} to ${dailyCostArray[dailyCostArray.length-1].date}` : 
      "No data"
    );
    console.log("Total cost:", dailyCostArray.reduce((sum, item) => sum + item.cost, 0).toFixed(2));
    console.log("========== END OF DAILY COST CALCULATION ==========");
    
    // Chart güncelleme artık sadece App Campaign endpoint'i tarafından yapılıyor
    
    return dailyCostArray;
  };
  
  // Function to update chart with App Campaign daily trend data
  const updateAppCampaignChart = (dailyTrendData) => {
    if (!dailyTrendData || dailyTrendData.length === 0) {
      console.log("No app campaign daily trend data available - setting chart to zeros");
      // Set chart to show zeros instead of clearing
      const zeroChartData = {
        labels: [],
        datasets: [
          {
            label: 'Cost',
            data: [],
            borderColor: 'rgb(59, 130, 246)',
            backgroundColor: 'rgba(59, 130, 246, 0.1)',
            fill: false,
            tension: 0.4,
            yAxisID: 'y'
          },
          {
            label: 'Installs',
            data: [],
            borderColor: 'rgb(16, 185, 129)',
            backgroundColor: 'rgba(16, 185, 129, 0.1)',
            fill: false,
            tension: 0.4,
            yAxisID: 'y1'
          }
        ]
      };
      setChartData(zeroChartData);
      console.log("App campaign chart set to zeros");
      return;
    }
    
    // Format dates for display
    const labels = dailyTrendData.map(item => {
      const date = new Date(item.date);
      return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
    });
    
    // Extract cost and install values
    console.log("Daily trend data for chart:", dailyTrendData);
    
    const costs = dailyTrendData.map(item => {
      // Try different cost field names that might come from the API
      const cost = Number(item.cost || item.cost_micros / 1000000 || 0);
      console.log(`Date: ${item.date}, Cost: ${cost}, Raw cost: ${item.cost}, Raw cost_micros: ${item.cost_micros}`);
      return cost;
    });
    const installs = dailyTrendData.map(item => item.conversions || 0);
    
    // Update chart data
    const newChartData = {
      labels: labels,
      datasets: [
        {
          label: 'Cost',
          data: costs,
          borderColor: 'rgb(59, 130, 246)',
          backgroundColor: 'rgba(59, 130, 246, 0.1)',
          fill: false,
          tension: 0.4,
          yAxisID: 'y'
        },
        {
          label: 'Installs',
          data: installs,
          borderColor: 'rgb(16, 185, 129)',
          backgroundColor: 'rgba(16, 185, 129, 0.1)',
          fill: false,
          tension: 0.4,
          yAxisID: 'y1'
        }
      ]
    };
    
    setChartData(newChartData);
    console.log("App campaign chart updated with new data", newChartData);
  };

  // updateDailyCostChart fonksiyonu kaldırıldı - updateAppCampaignChart kullanılıyor
  
  // Performans trend verilerini çekmek için yeni fonksiyon
  const fetchPerformanceTrend = async () => {
    try {
      setIsLoadingTrend(true);
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) {
        console.error('No brand ID found in localStorage');
        setIsLoadingTrend(false);
        return;
      }
      
      // Use fetch API instead of axios
      const trendParams = new URLSearchParams();
      if (gaAccountFilter !== 'all') trendParams.set('accountId', gaAccountFilter);
      const trendUrl = `https://api.glowytics.com/api/google-ads/performance-trend${trendParams.toString() ? '?' + trendParams.toString() : ''}`;
      const response = await fetch(trendUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include',
      });

      if (!response.ok) {
        // Don't try to parse JSON if response is not OK
        console.error('API Error:', response.status, response.statusText);
        throw new Error(`Failed to fetch performance trend: ${response.statusText}`);
      }

      const data = await response.json();
      console.log("API Performance Trend Response:", data);
      
      if (data && data.trend) {
        setTrendData(data.trend);
      } else {
        setTrendData([]);
      }
      setIsLoadingTrend(false);
    } catch (error) {
      console.error("Error fetching performance trend:", error);
      setTrendData([]);
      setIsLoadingTrend(false);
      // Don't show error toast
    }
  };
  
  // Keyword verilerinden trend verilerini oluşturan yardımcı fonksiyon
  const generateTrendDataFromKeywords = () => {
    try {
      if (!keywordData || !Array.isArray(keywordData) || keywordData.length === 0) {
        console.log("No keyword data available for trend generation");
        return;
      }

      // Create a map to store metrics by date
      const metricsByDate = new Map();

      // Process all keywords directly from keywordData
      keywordData.forEach(keyword => {
        if (keyword.date) {
          const date = keyword.date;
          
          if (!metricsByDate.has(date)) {
            metricsByDate.set(date, {
              date,
              impressions: 0,
              clicks: 0,
              cost: 0,
              conversions: 0,
              conversionValue: 0
            });
          }

          const metrics = metricsByDate.get(date);
          metrics.impressions += parseInt(keyword.impressions || 0, 10);
          metrics.clicks += parseInt(keyword.clicks || 0, 10);
          metrics.cost += parseFloat(keyword.cost || 0);
          metrics.conversions += parseInt(keyword.conversions || 0, 10);
          metrics.conversionValue += parseFloat(keyword.conversion_value || 0);
        }
      });

      // Convert to array and sort by date
      const trendData = Array.from(metricsByDate.values())
        .sort((a, b) => new Date(a.date) - new Date(b.date));

      // Calculate derived metrics
      trendData.forEach(day => {
        day.ctr = day.impressions > 0 ? (day.clicks / day.impressions) * 100 : 0;
        day.cpc = day.clicks > 0 ? day.cost / day.clicks : 0;
        day.convRate = day.clicks > 0 ? (day.conversions / day.clicks) * 100 : 0;
        day.cpa = day.conversions > 0 ? day.cost / day.conversions : 0;
        day.roas = day.cost > 0 ? day.conversionValue / day.cost : 0;
      });

      console.log("Generated trend data from keywords:", trendData);
      
      return trendData;
    } catch (error) {
      console.error("Error generating trend data:", error);
      return [];
    }
  };
  
  // generateEmptyTrendData fonksiyonu kaldırıldı - artık gereksiz

  // Normalize campaign status to 'ENABLED' or 'PAUSED'
  const cleanStatus = (s) => {
    if (!s) return '';
    const cleaned = s.replace('CampaignStatus.', '').trim().toUpperCase();
    if (cleaned === 'ACTIVE' || cleaned === 'ENABLED') return 'ENABLED';
    if (cleaned === 'PAUSED') return 'PAUSED';
    return cleaned;
  };

  // Update campaign status or budget via live Google Ads API
  const updateEntity = useCallback(async (entityType, entityId, field, value, campaignId, oldValue, entityName) => {
    setUpdatingId(campaignId);
    setOpenStatusDropdown(null);
    try {
      const response = await fetch('https://api.glowytics.com/api/labs/google-ads/campaigns-update', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': selectedBrand.id
        },
        body: JSON.stringify({ entityType, entityId, field, value, oldValue, entityName }),
        credentials: 'include'
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || data.details?.error || 'Update failed');
      if (data.success) {
        toast.success('Updated successfully');
        setLiveDataMap(prev => {
          const key = String(campaignId);
          const existing = prev[key] || {};
          if (field === 'status') {
            return { ...prev, [key]: { ...existing, status: value } };
          } else if (field === 'amount_micros') {
            return { ...prev, [key]: { ...existing, budget: parseInt(value) / 1000000 } };
          }
          return prev;
        });
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setUpdatingId(null);
      setEditBudget(null);
    }
  }, [selectedBrand?.id]);

  const handleSaveBudget = useCallback((campaignId, campaignName) => {
    if (!editBudget || editBudget.id !== campaignId) return;
    const newValue = parseFloat(editBudget.value);
    const micros = Math.round(newValue * 1000000);
    if (isNaN(micros) || micros <= 0) {
      toast.error('Invalid budget amount');
      return;
    }
    const live = liveDataMap[String(campaignId)];
    if (!live?.budgetId) {
      toast.error('Budget ID not found for this campaign');
      return;
    }
    const oldBudgetMicros = live.budget ? Math.round(live.budget * 1000000) : null;
    setConfirmDialog({
      title: 'Change Budget',
      message: `Are you sure you want to change the budget to ₺${newValue.toLocaleString('tr-TR')}?`,
      variant: 'budget',
      onConfirm: () => {
        updateEntity('budget', live.budgetId, 'amount_micros', micros, campaignId, oldBudgetMicros ? String(oldBudgetMicros) : null, campaignName || null);
        setConfirmDialog(null);
      }
    });
  }, [editBudget, liveDataMap, updateEntity]);

  // Fetch change history data
  const fetchChangeHistory = useCallback(async (offset = 0, append = false) => {
    if (!selectedBrand?.id) return;
    setChangeHistoryLoading(true);
    try {
      const params = new URLSearchParams({ limit: '50', offset: String(offset) });
      if (changeHistoryFilter !== 'all') params.set('action', changeHistoryFilter);
      const response = await fetch(`https://api.glowytics.com/api/labs/ads-change-history?${params}`, {
        headers: { 'X-Brand-ID': selectedBrand.id },
        credentials: 'include'
      });
      const result = await response.json();
      if (result.success) {
        setChangeHistoryData(prev => append ? [...prev, ...result.data] : result.data);
        setChangeHistoryTotal(result.total);
      }
    } catch (err) {
      console.error('Failed to fetch change history:', err);
    } finally {
      setChangeHistoryLoading(false);
    }
  }, [selectedBrand?.id, changeHistoryFilter]);

  useEffect(() => {
    if (showChangeHistory) fetchChangeHistory(0);
  }, [showChangeHistory, fetchChangeHistory]);

  // Fetch live status + daily budget from Google Ads API
  const fetchLiveCampaignData = useCallback(async () => {
    if (!selectedBrand?.id) return;
    setIsLoadingLive(true);
    try {
      const response = await fetch('https://api.glowytics.com/api/labs/google-ads/campaigns-live', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': selectedBrand.id
        },
        credentials: 'include'
      });
      const data = await response.json();
      console.log('[AppCampaigns] campaigns-live response:', { ok: response.ok, success: data.success, count: data.campaigns?.length, error: data.error });
      if (response.ok && data.success && Array.isArray(data.campaigns)) {
        const map = {};
        data.campaigns.forEach(c => {
          if (c.id != null) {
            map[String(c.id)] = {
              id: c.id,
              status: c.status || null,
              budget: c.budget != null ? c.budget : null,
              budgetId: c.budgetId || null
            };
          }
        });
        console.log('[AppCampaigns] liveDataMap keys:', Object.keys(map));
        setLiveDataMap(map);
      } else {
        console.warn('[AppCampaigns] campaigns-live failed:', { status: response.status, error: data.error });
      }
    } catch (e) {
      console.error('[AppCampaigns] campaigns-live fetch error:', e);
    } finally {
      setIsLoadingLive(false);
    }
  }, [selectedBrand?.id]);

  // Fetch live data once on mount and whenever brand changes
  useEffect(() => {
    fetchLiveCampaignData();
  }, [fetchLiveCampaignData]);

  // Find and update the formatNumber function or any other function that formats currency values
  const formatNumber = (value, options = {}) => {
    if (value === undefined || value === null) return '0';
    
    const {
      prefix = '',
      suffix = '',
      minimumFractionDigits = 2,
      maximumFractionDigits = 2,
      notation = 'standard'
    } = options;
    
    // Remove any existing currency symbol from the value if it's a string
    let numericValue = value;
    if (typeof value === 'string') {
      numericValue = value.replace(/[₺$€£¥]/g, '');
    }
    
    // Convert to number
    numericValue = parseFloat(numericValue);
    
    // Format the number
    return `${prefix}${numericValue.toLocaleString(undefined, {
      minimumFractionDigits,
      maximumFractionDigits,
      notation
    })}${suffix}`;
  };

  // Get summary metrics
  // Summary metrics hesaplaması - App Campaign verileri varsa onları kullan
  const summaryMetrics = (() => {
    const tm = appCampaignsData && appCampaignsData.totalMetrics ? appCampaignsData.totalMetrics : null;
    if (tm) {
      const ga4Rev = tm.ga4Revenue || 0;
      const cost = tm.cost || 0;
      const ga4Conversions = tm.ga4Transactions || 0;
      const sessions = tm.sessions || 0;
      return {
        ...tm,
        conversions: tm.conversions || 0,
        costPerConversion: tm.costPerConversion || 0,
        conversionRate: tm.conversionRate || 0,
        cost,
        cpc: tm.cpc || 0,
        impressions: tm.impressions || 0,
        clicks: tm.clicks || 0,
        ctr: tm.ctr || 0,
        ga4Revenue: ga4Rev,
        ga4Roas: cost > 0 ? ga4Rev / cost : 0,
        ga4Conversions,
        ga4ConversionRate: sessions > 0 ? ga4Conversions / sessions : 0,
        sessions,
        ga4Transactions: tm.ga4Transactions || 0,
        adjustSessions: tm.adjustSessions || 0,
        adjustInstalls: tm.adjustInstalls || 0,
        adjustPurchaseEvents: tm.adjustPurchaseEvents || 0,
        adjustAllRevenue: tm.adjustAllRevenue || 0
      };
    }
    return calculateSummaryMetrics(campaigns);
  })();
  const cps = summaryMetrics.sessions > 0 ? (summaryMetrics.cost || 0) / summaryMetrics.sessions : 0;

  // useEffect içinde, sayfa yüklendiğinde varsayılan olarak budget'a göre sırala
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        // Veri çekme işlemleri...
        
        // Varsayılan olarak budget'a göre azalan sıralama yap
        setSortField('budget');
        setSortDirection('desc');
        
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [dateRange]);

  // Kampanyaları sırala
  const sortedCampaigns = [...campaigns].sort((a, b) => {
    // Sayısal değerler için sıralama
    if (['spend', 'budget', 'impressions', 'clicks', 'ctr', 'cpc', 'conversions', 'conversionRate', 'costPerConversion', 'conversionValue', 'roas'].includes(sortField)) {
      // Sayısal değerleri güvenli bir şekilde al
      const aValue = parseFloat(a[sortField]) || 0;
      const bValue = parseFloat(b[sortField]) || 0;
      
      return sortDirection === 'asc' 
        ? aValue - bValue 
        : bValue - aValue;
    }
    
    // Metin değerleri için sıralama (kampanya adı, durum vb.)
    if (['name', 'status', 'text'].includes(sortField)) {
      const aValue = String(a[sortField] || '').toLowerCase();
      const bValue = String(b[sortField] || '').toLowerCase();
      
      if (sortDirection === 'asc') {
        return aValue.localeCompare(bValue);
      } else {
        return bValue.localeCompare(aValue);
      }
    }
    
    // Varsayılan olarak budget'a göre azalan sıralama
    return b.budget - a.budget;
  });

  // Adjust verisi var mı kontrol et
  const hasAdjust = useMemo(() => {
    const campaignsToShow = appCampaignsData?.campaigns && appCampaignsData.campaigns.length > 0 
      ? appCampaignsData.campaigns 
      : sortedCampaigns;
    return campaignsToShow.some(c =>
      ((c.adjustSessions || c.adjust_sessions || 0) +
        (c.adjustInstalls || c.adjust_installs || 0) +
        (c.adjustPurchaseEvents || c.adjust_purchase_events || 0) +
        (c.adjustAllRevenue || c.adjust_all_revenue || 0)) > 0
    );
  }, [appCampaignsData, sortedCampaigns]);

  // Ad Group'ları sırala
  const sortAdGroups = (adGroups, field, direction) => {
    if (!field) return adGroups;

    return [...adGroups].sort((a, b) => {
      // Sayısal değerler için sıralama
      if (['spend', 'budget', 'impressions', 'clicks', 'ctr', 'cpc', 'conversions', 'conversionRate', 'costPerConversion', 'conversionValue', 'roas'].includes(field)) {
        // Sayısal değerleri güvenli bir şekilde al
        const aValue = parseFloat(a[field]) || 0;
        const bValue = parseFloat(b[field]) || 0;
        
        return direction === 'asc' 
          ? aValue - bValue 
          : bValue - aValue;
      }
      
      // Metin değerleri için sıralama (ad group adı, durum vb.)
      if (['name', 'status', 'text'].includes(field)) {
        const aValue = String(a[field] || '').toLowerCase();
        const bValue = String(b[field] || '').toLowerCase();
        
        if (direction === 'asc') {
          return aValue.localeCompare(bValue);
        } else {
          return bValue.localeCompare(aValue);
        }
      }
      
      // Varsayılan olarak budget'a göre azalan sıralama
      return b.budget - a.budget;
    });
  };

  // Dropdown'ı kapatmak için click-outside handler ekleyin
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isDateDropdownOpen) {
        setIsDateDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isDateDropdownOpen]);

  return (
    <div className="p-6 space-y-6 bg-[#f6f8ff]/70 w-full max-w-[100vw] overflow-x-hidden box-border">
      {/* Confirmation Dialog */}
      {confirmDialog && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={() => setConfirmDialog(null)} />
          <div className="relative bg-white rounded-2xl shadow-2xl border border-gray-100 w-full max-w-md mx-4 overflow-hidden animate-in fade-in zoom-in-95 duration-200">
            <div className={`px-6 pt-6 pb-4 flex items-start gap-4 ${confirmDialog.variant === 'pause' ? 'bg-orange-50/50' : confirmDialog.variant === 'enable' ? 'bg-green-50/50' : 'bg-blue-50/50'}`}>
              <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${confirmDialog.variant === 'pause' ? 'bg-orange-100' : confirmDialog.variant === 'enable' ? 'bg-green-100' : 'bg-blue-100'}`}>
                <AlertTriangle className={`w-5 h-5 ${confirmDialog.variant === 'pause' ? 'text-orange-600' : confirmDialog.variant === 'enable' ? 'text-green-600' : 'text-blue-600'}`} />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900">{confirmDialog.title}</h3>
                <p className="mt-1 text-sm text-gray-600">{confirmDialog.message}</p>
              </div>
            </div>
            <div className="px-6 py-4 bg-gray-50/80 flex items-center justify-end gap-3">
              <button onClick={() => setConfirmDialog(null)} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">Cancel</button>
              <button onClick={confirmDialog.onConfirm} className={`px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors ${confirmDialog.variant === 'pause' ? 'bg-orange-500 hover:bg-orange-600' : confirmDialog.variant === 'enable' ? 'bg-green-500 hover:bg-green-600' : 'bg-blue-500 hover:bg-blue-600'}`}>Confirm</button>
            </div>
          </div>
        </div>
      )}
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-center bg-white px-5 py-3 rounded-2xl shadow-sm w-full gap-3 md:gap-0 min-w-0">
        <div className="flex items-center gap-2.5 w-full md:w-auto">
          <img
            src="/app.svg"
            alt="App Campaigns"
            className="w-7 h-7 object-contain"
          />
          <h1 className="text-lg font-semibold text-gray-900">App Campaigns</h1>
        </div>

        <div className="flex flex-wrap items-center gap-3 justify-center md:justify-end w-full md:w-auto">
          {/* Account Switcher */}
          <AccountSwitcher platform="GOOGLE_ADS" />

          {/* Seçili tarih aralığı */}
          <div className="text-xs text-gray-500">
            {(() => {
              switch (dateRange) {
                case 'today':
                  return new Date().toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
                case 'yesterday':
                  const yesterday = new Date();
                  yesterday.setDate(yesterday.getDate() - 1);
                  return yesterday.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
                case 'last7':
                  const last7 = new Date();
                  last7.setDate(last7.getDate() - 7);
                  return `${last7.toLocaleDateString('en-US', { day: 'numeric', month: 'short' })} - ${new Date().toLocaleDateString('en-US', { day: 'numeric', month: 'short' })}`;
                case 'last30':
                  const last30 = new Date();
                  last30.setDate(last30.getDate() - 30);
                  return `${last30.toLocaleDateString('en-US', { day: 'numeric', month: 'short' })} - ${new Date().toLocaleDateString('en-US', { day: 'numeric', month: 'short' })}`;
                case 'thisMonth':
                  const firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                  return `${firstDay.toLocaleDateString('en-US', { day: 'numeric', month: 'short' })} - ${new Date().toLocaleDateString('en-US', { day: 'numeric', month: 'short' })}`;
                case 'lastMonth':
                  const lastMonthFirstDay = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
                  const lastMonthLastDay = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
                  return `${lastMonthFirstDay.toLocaleDateString('en-US', { day: 'numeric', month: 'short' })} - ${lastMonthLastDay.toLocaleDateString('en-US', { day: 'numeric', month: 'short' })}`;
                case 'custom':
                  if (customStartDate && customEndDate) {
                    return `${customStartDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short' })} - ${customEndDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short' })}`;
                  }
                  return 'Custom Range';
                default:
                  return '';
              }
            })()}
          </div>

          {/* Google Ads Account Filter */}
          {gaAccounts.length >= 2 && (
            <select
              value={gaAccountFilter}
              onChange={(e) => setGaAccountFilter(e.target.value)}
              className="px-4 py-2 border border-gray-200 rounded-xl text-sm bg-white shadow-sm hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
            >
              <option value="all">All Accounts</option>
              {gaAccounts.map(acc => (
                <option key={acc.customerId} value={acc.customerId}>
                  {acc.nickname || acc.accountName || acc.customerId}
                </option>
              ))}
            </select>
          )}

          {/* Unified date range filter (replaces legacy dropdown + modal) */}
          <DateRangeFilter
            value={dateRange}
            customStart={customStartDate}
            customEnd={customEndDate}
            onChange={(range, start, end) => {
              setDateRange(range);
              setCustomStartDate(start);
              setCustomEndDate(end);
            }}
            presets={['yesterday', 'last7', 'last30', 'thisMonth', 'lastMonth', 'custom']}
          />

        </div>
      </div>

      <Ga4WebOnlyNote />

      {/* Performance Overview */}
      <div className="grid grid-cols-12 gap-6">
        {/* Chart */}
        <Card className="col-span-8 rounded-2xl overflow-hidden bg-white">
          <div className="p-6 border-b border-gray-100">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-lg font-semibold text-gray-900">App Campaign Performance</h2>
                <p className="text-sm text-gray-500 mt-1">Installs, in-app actions and cost metrics</p>
              </div>
            </div>
          </div>
          <div className="p-6">
            <div className="h-[300px]">
              {dataLoading ? (
                <div className="h-full flex items-center justify-center">
                  <div className="loading-logo-container">
                    <img 
                      src="/logoicon.png" 
                      alt="Glowytics Logo" 
                      className="loading-logo"
                    />
                  </div>
                </div>
              ) : (
                <Line data={chartData} options={chartOptions} />
              )}
            </div>
          </div>
        </Card>

        {/* Key Metrics - kartların sırasını değiştirdik */}
        <div className="col-span-1 lg:col-span-4 grid grid-cols-1 gap-3 min-w-0">
          {/* Row 1: Revenue, GA4 Revenue */}
          <div className="grid grid-cols-2 gap-3 min-w-0">
            {/* Revenue Card */}
            <div className="bg-white rounded-xl shadow-sm p-3">
              <div className="flex justify-between items-center">
                <p className="text-gray-500 text-xs">Revenue</p>
                <img src="/google_ads-512.webp" alt="Google Ads" className="w-4 h-4" />
              </div>
              <div className="mt-2 text-center">
                <h3 className="text-2xl font-bold text-gray-800 truncate" title={(!isNaN(summaryMetrics.revenue) && summaryMetrics.revenue ? Math.floor(summaryMetrics.revenue).toLocaleString('tr-TR') : '0')}>
                  ₺{(!isNaN(summaryMetrics.revenue) && summaryMetrics.revenue ? Math.floor(summaryMetrics.revenue).toLocaleString('tr-TR') : '0')}
                </h3>
                <p className="text-xs text-gray-500">{formatNumber(summaryMetrics.roas || 0)}x ROAS</p>
              </div>
            </div>
            {/* GA4 Revenue Card */}
            <div className="bg-white rounded-xl shadow-sm p-3">
              <div className="flex justify-between items-center">
                <div className="text-gray-500 text-xs flex items-center gap-1">
                  <img src="/GA4logoicon.svg" alt="GA4" className="w-4 h-4" />
                  <span>Revenue</span>
                </div>
              </div>
              <div className="mt-2 text-center">
                <h3 className="text-2xl font-bold text-gray-800 truncate" title={(!isNaN(summaryMetrics.ga4Revenue) && summaryMetrics.ga4Revenue ? Math.floor(summaryMetrics.ga4Revenue).toLocaleString('tr-TR') : '0')}>
                  ₺{(!isNaN(summaryMetrics.ga4Revenue) && summaryMetrics.ga4Revenue ? Math.floor(summaryMetrics.ga4Revenue).toLocaleString('tr-TR') : '0')}
                </h3>
                <p className="text-xs text-gray-500">{formatNumber(summaryMetrics.ga4Roas || 0)}x ROAS</p>
              </div>
            </div>
          </div>

          {/* Row 2: Cost, Conversions */}
          <div className="grid grid-cols-2 gap-3">
            {/* Cost Card */}
            <div className="bg-white rounded-xl shadow-sm p-3">
              <div className="flex justify-between items-center">
                <p className="text-gray-500 text-xs">Cost</p>
                <img src="/google_ads-512.webp" alt="Google Ads" className="w-4 h-4" />
              </div>
              <div className="mt-2 text-center">
                <h3 className="text-2xl font-bold text-gray-800 truncate" title={(!isNaN(summaryMetrics.cost) && summaryMetrics.cost ? Math.floor(summaryMetrics.cost).toLocaleString('tr-TR') : '0')}>
                  ₺{(!isNaN(summaryMetrics.cost) && summaryMetrics.cost ? Math.floor(summaryMetrics.cost).toLocaleString('tr-TR') : '0')}
                </h3>
                <p className="text-xs text-gray-500">&nbsp;</p>
              </div>
            </div>
            {/* Conversions Card (Combined) */}
            <div className="bg-white rounded-xl shadow-sm p-3">
              <div className="flex justify-between items-center">
                <p className="text-gray-500 text-xs">Conversions</p>
                <div className="flex items-center gap-1">
                  <img src="/google_ads-512.webp" alt="Google Ads" className="w-3 h-3" />
                  <img src="/GA4logoicon.svg" alt="GA4" className="w-3 h-3" />
                </div>
              </div>
              <div className="flex items-center justify-around mt-2">
                {/* Ads Data */}
                <div className="text-center">
                  <p className="text-xl font-bold text-gray-800">{summaryMetrics.conversions || 0}</p>
                  <p className="text-[10px] text-gray-500">%{formatNumber(summaryMetrics.conversionRate ? summaryMetrics.conversionRate * 100 : 0, {maximumFractionDigits: 2})} CR</p>
                </div>
                {/* Separator */}
                <div className="h-10 border-l border-gray-200"></div>
                {/* GA4 Data */}
                <div className="text-center">
                  <p className="text-xl font-bold text-gray-800">{summaryMetrics.ga4Conversions || 0}</p>
                  <p className="text-[10px] text-gray-500">%{formatNumber(summaryMetrics.ga4ConversionRate ? summaryMetrics.ga4ConversionRate * 100 : 0, {maximumFractionDigits: 2})} CR</p>
                </div>
              </div>
            </div>
          </div>

          {/* Row 3: Clicks, Sessions */}
          <div className="grid grid-cols-2 gap-3">
            {/* Clicks Card */}
            <div className="bg-white rounded-xl shadow-sm p-3">
              <div className="flex justify-between items-center">
                <p className="text-gray-500 text-xs">Clicks</p>
                <img src="/google_ads-512.webp" alt="Google Ads" className="w-4 h-4" />
              </div>
              <div className="mt-2 text-center">
                <h3 className="text-2xl font-bold text-gray-800 truncate" title={formatNumber(summaryMetrics.clicks || 0, {minimumFractionDigits: 0, maximumFractionDigits: 0})}>{formatNumber(summaryMetrics.clicks || 0, {minimumFractionDigits: 0, maximumFractionDigits: 0})}</h3>
                <p className="text-xs text-gray-500">&nbsp;</p>
              </div>
            </div>
            {/* Sessions Card */}
            <div className="bg-white rounded-xl shadow-sm p-3">
              <div className="flex justify-between items-center">
                <p className="text-gray-500 text-xs">Sessions</p>
                {hasAdjust ? (
                  <div className="flex items-center gap-1">
                    <img src="/adjustlogopng.png" alt="Adjust" className="w-3 h-3" />
                    <img src="/GA4logoicon.svg" alt="GA4" className="w-3 h-3" />
                  </div>
                ) : (
                  <img src="/GA4logoicon.svg" alt="GA4" className="w-4 h-4" />
                )}
              </div>
              {hasAdjust ? (
                <div className="flex items-center justify-around mt-2">
                  {/* Adjust Sessions */}
                  <div className="text-center w-full min-w-0">
                    <p className="text-xl font-bold text-gray-800 truncate" title={formatNumber(summaryMetrics.adjustSessions || 0, {minimumFractionDigits: 0, maximumFractionDigits: 0})}>{formatNumber(summaryMetrics.adjustSessions || 0, {minimumFractionDigits: 0, maximumFractionDigits: 0})}</p>
                    <p className="text-[10px] text-gray-500">Adj. Sessions</p>
                  </div>
                  {/* Separator */}
                  <div className="h-10 border-l border-gray-200"></div>
                  {/* GA4 Sessions */}
                  <div className="text-center w-full min-w-0">
                    <p className="text-xl font-bold text-gray-800 truncate" title={formatNumber(summaryMetrics.sessions || 0, {minimumFractionDigits: 0, maximumFractionDigits: 0})}>{formatNumber(summaryMetrics.sessions || 0, {minimumFractionDigits: 0, maximumFractionDigits: 0})}</p>
                    <div className="flex items-center justify-center gap-1 text-[10px] text-gray-500">
                      <img src="/GA4logoicon.svg" alt="GA4" className="w-3 h-3" />
                      <span>Sessions</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="mt-2 text-center">
                  <h3 className="text-2xl font-bold text-gray-800 truncate" title={formatNumber(summaryMetrics.sessions || 0, {minimumFractionDigits: 0, maximumFractionDigits: 0})}>{formatNumber(summaryMetrics.sessions || 0, {minimumFractionDigits: 0, maximumFractionDigits: 0})}</h3>
                  <div className="flex items-center justify-center gap-1 text-[10px] text-gray-500">
                    <img src="/GA4logoicon.svg" alt="GA4" className="w-3 h-3" />
                    <span>Sessions</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Row 4: CPC, CPS */}
          <div className="grid grid-cols-2 gap-3">
            {/* CPC Card */}
            <div className="bg-white rounded-xl shadow-sm p-3">
              <div className="flex justify-between items-center">
                <p className="text-gray-500 text-xs">CPC</p>
                <img src="/google_ads-512.webp" alt="Google Ads" className="w-4 h-4" />
              </div>
              <div className="mt-2 text-center">
                <h3 className="text-2xl font-bold text-gray-800">₺{(summaryMetrics.cpc || 0).toFixed(2)}</h3>
                <p className="text-xs text-gray-500">&nbsp;</p>
              </div>
            </div>
            {/* CPS Card */}
            <div className="bg-white rounded-xl shadow-sm p-3">
              <div className="flex justify-between items-center">
                <p className="text-gray-500 text-xs">CPS</p>
                <img src="/GA4logoicon.svg" alt="GA4" className="w-4 h-4" />
              </div>
              <div className="mt-2 text-center">
                <h3 className="text-2xl font-bold text-gray-800">₺{cps.toFixed(2)}</h3>
                <p className="text-xs text-gray-500">&nbsp;</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Campaign Performance Table with Ad Groups */}
      <Card className="rounded-2xl overflow-hidden bg-white">
        <div className="p-6 border-b border-gray-100">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-lg font-semibold text-gray-900">App Campaign Performance</h2>
              <p className="text-sm text-gray-500 mt-1">Detailed metrics for app install and engagement campaigns</p>
            </div>
          </div>
        </div>
        <div className="overflow-x-auto">
          {dataLoading ? (
            <div className="min-h-[400px] flex items-center justify-center">
              <div className="loading-logo-container">
                <img 
                  src="/logoicon.png" 
                  alt="Glowytics Logo" 
                  className="loading-logo"
                />
              </div>
            </div>
          ) : (appCampaignsData?.campaigns || campaigns).length === 0 ? (
            <div className="flex justify-center items-center p-12">
              <div className="text-center">
                <p className="text-gray-600 mb-2">No campaign data available</p>
                <p className="text-sm text-gray-500">Connect your Google Ads account to see campaign performance</p>
              </div>
            </div>
          ) : (
            <table className="w-full border-collapse">
              <thead>
                <tr>
                  <th
                    className="text-left py-2 px-3 text-[11px] font-medium text-gray-600 uppercase tracking-wider border-b border-r border-gray-200 cursor-pointer hover:bg-gray-50"
                    onClick={() => handleSort('text')}
                  >
                    Campaign / Ad Group
                    {sortField === 'text' && (
                      <span className="ml-1">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                    )}
                  </th>
                  <th
                    className="text-right py-2 px-3 text-[11px] font-medium text-gray-600 uppercase tracking-wider border-b border-r border-gray-200 cursor-pointer hover:bg-gray-50"
                    onClick={() => handleSort('budget')}
                  >
                    Budget
                    {sortField === 'budget' && (
                      <span className="ml-1">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                    )}
                  </th>
                  <th
                    className="text-right py-2 px-3 text-[11px] font-medium text-gray-600 uppercase tracking-wider border-b border-gray-200 cursor-pointer hover:bg-gray-50"
                    onClick={() => handleSort('spend')}
                  >
                    Cost
                    {sortField === 'spend' && (
                      <span className="ml-1">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                    )}
                  </th>
                  <th 
                    className="text-right py-2 px-3 text-[11px] font-medium text-gray-600 uppercase tracking-wider border-b border-r border-gray-200 cursor-pointer hover:bg-gray-50"
                    onClick={() => handleSort('impressions')}
                  >
                    Impr.
                    {sortField === 'impressions' && (
                      <span className="ml-1">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                    )}
                  </th>
                  <th 
                    className="text-right py-2 px-3 text-[11px] font-medium text-gray-600 uppercase tracking-wider border-b border-r border-gray-200 cursor-pointer hover:bg-gray-50"
                    onClick={() => handleSort('clicks')}
                  >
                    Clicks
                    {sortField === 'clicks' && (
                      <span className="ml-1">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                    )}
                  </th>
                  <th 
                    className="text-right py-2 px-3 text-[11px] font-medium text-gray-600 uppercase tracking-wider border-b border-r border-gray-200 cursor-pointer hover:bg-gray-50"
                    onClick={() => handleSort('ctr')}
                  >
                    CTR
                    {sortField === 'ctr' && (
                      <span className="ml-1">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                    )}
                  </th>
                  <th 
                    className="text-right py-2 px-3 text-[11px] font-medium text-gray-600 uppercase tracking-wider border-b border-r border-gray-200 cursor-pointer hover:bg-gray-50"
                    onClick={() => handleSort('cpc')}
                  >
                    Avg. CPC
                    {sortField === 'cpc' && (
                      <span className="ml-1">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                    )}
                  </th>
                  <th 
                    className="text-right py-2 px-3 text-[11px] font-medium text-gray-600 uppercase tracking-wider border-b border-r border-gray-200 cursor-pointer hover:bg-gray-50"
                    onClick={() => handleSort('conversions')}
                  >
                    Installs
                    {sortField === 'conversions' && (
                      <span className="ml-1">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                    )}
                  </th>
                  <th 
                    className="text-right py-2 px-3 text-[11px] font-medium text-gray-600 uppercase tracking-wider border-b border-r border-gray-200 cursor-pointer hover:bg-gray-50"
                    onClick={() => handleSort('conversionRate')}
                  >
                    Install Rate
                    {sortField === 'conversionRate' && (
                      <span className="ml-1">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                    )}
                  </th>
                  <th 
                    className="text-right py-2 px-3 text-[11px] font-medium text-gray-600 uppercase tracking-wider border-b border-r border-gray-200 cursor-pointer hover:bg-gray-50"
                    onClick={() => handleSort('costPerConversion')}
                  >
                    Cost/Install
                    {sortField === 'costPerConversion' && (
                      <span className="ml-1">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                    )}
                  </th>
                  {hasAdjust && (
                    <>
                      <th className="text-right py-2 px-3 text-[11px] font-medium text-gray-600 uppercase tracking-wider border-b border-r border-gray-200">Adj. Sessions</th>
                      <th className="text-right py-2 px-3 text-[11px] font-medium text-gray-600 uppercase tracking-wider border-b border-r border-gray-200">Adj. Installs</th>
                      <th className="text-right py-2 px-3 text-[11px] font-medium text-gray-600 uppercase tracking-wider border-b border-r border-gray-200">Adj. Purchases</th>
                      <th className="text-right py-2 px-3 text-[11px] font-medium text-gray-600 uppercase tracking-wider border-b border-r border-gray-200">Adj. Revenue</th>
                    </>
                  )}
                  <th className="text-right py-2 px-3 text-[11px] font-medium text-gray-600 uppercase tracking-wider border-b border-gray-200 cursor-pointer hover:bg-gray-50"
                    onClick={() => handleSort('roas')}>ROAS</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {(() => {
                  // App campaign data varsa onu kullan, yoksa keyword'lerden organize edilmiş kampanyaları kullan
                  const campaignsToShow = appCampaignsData?.campaigns && appCampaignsData.campaigns.length > 0 
                    ? appCampaignsData.campaigns 
                    : sortedCampaigns;
                  
                  return campaignsToShow.map((campaign) => (
                    <React.Fragment key={campaign.id}>
                      {/* Campaign Row */}
                      <tr
                        className={`group/row hover:bg-blue-50/30 cursor-pointer transition-colors ${
                          expandedCampaigns.has(campaign.id) ? 'bg-blue-50/50' : 'bg-white'
                        }`}
                        onClick={(e) => toggleCampaign(campaign.id, e)}
                      >
                        <td className="py-2.5 px-3 border-r border-gray-200 relative">
                          <div className="flex items-center gap-2">
                            {/* Expansion Icon */}
                            <div className="flex items-center justify-center w-5 h-5">
                              {campaign.adGroups && campaign.adGroups.length > 0 ? (
                                expandedCampaigns.has(campaign.id) ?
                                <ChevronDown className="w-4 h-4 text-blue-500" /> :
                                <ChevronRight className="w-4 h-4 text-gray-400" />
                              ) : (
                                <span className="w-4 h-4"></span>
                              )}
                            </div>
                            {/* Status dot + hover arrow + Dropdown */}
                            {(() => {
                              const live = liveDataMap[String(campaign.id)];
                              const resolvedStatus = cleanStatus(live?.status || campaign.status || '');
                              const liveId = live?.id || campaign.id;
                              return (
                                <>
                                  <button
                                    onClick={(e) => { e.stopPropagation(); setOpenStatusDropdown(openStatusDropdown === campaign.id ? null : campaign.id); }}
                                    disabled={updatingId === campaign.id}
                                    className="flex-shrink-0 -ml-1 flex items-center gap-0.5 px-1 py-1 rounded-md hover:bg-gray-100 transition-colors focus:outline-none group/dot"
                                    title={resolvedStatus === 'ENABLED' ? 'Enabled — click to change' : 'Paused — click to change'}
                                  >
                                    {updatingId === campaign.id ? (
                                      <Loader2 className="w-2.5 h-2.5 animate-spin text-gray-500" />
                                    ) : (
                                      <div className={`w-2.5 h-2.5 rounded-full ${resolvedStatus === 'ENABLED' ? 'bg-green-500 shadow-[0_0_0_3px_rgba(34,197,94,0.15)]' : 'bg-gray-400 shadow-[0_0_0_3px_rgba(156,163,175,0.15)]'}`} />
                                    )}
                                    <ChevronDown className="w-3 h-3 text-gray-400 opacity-0 group-hover/row:opacity-100 transition-opacity" />
                                  </button>
                                  {openStatusDropdown === campaign.id && (
                                    <>
                                      <div className="fixed inset-0 z-10 cursor-default" onClick={() => setOpenStatusDropdown(null)} />
                                      <div className="absolute top-full left-8 mt-1 w-40 bg-white rounded-xl shadow-xl border border-gray-100 z-20 py-1 overflow-hidden animate-in fade-in zoom-in-95 duration-100 origin-top-left">
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setOpenStatusDropdown(null);
                                            setConfirmDialog({
                                              title: 'Enable Campaign',
                                              message: `Are you sure you want to enable campaign "${campaign.name || campaign.campaign_name}"?`,
                                              variant: 'enable',
                                              onConfirm: () => {
                                                updateEntity('campaign', liveId, 'status', 'ENABLED', campaign.id, resolvedStatus, campaign.name || campaign.campaign_name);
                                                setConfirmDialog(null);
                                              }
                                            });
                                          }}
                                          className={`w-full text-left px-4 py-2.5 text-sm hover:bg-gray-50 flex items-center gap-3 transition-colors ${resolvedStatus === 'ENABLED' ? 'text-green-600 bg-green-50/50' : 'text-gray-700'}`}
                                        >
                                          <div className="w-2 h-2 rounded-full bg-green-500" />
                                          <span>Enable</span>
                                          {resolvedStatus === 'ENABLED' && <Check className="w-3.5 h-3.5 ml-auto" />}
                                        </button>
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setOpenStatusDropdown(null);
                                            setConfirmDialog({
                                              title: 'Pause Campaign',
                                              message: `Are you sure you want to pause campaign "${campaign.name || campaign.campaign_name}"?`,
                                              variant: 'pause',
                                              onConfirm: () => {
                                                updateEntity('campaign', liveId, 'status', 'PAUSED', campaign.id, resolvedStatus, campaign.name || campaign.campaign_name);
                                                setConfirmDialog(null);
                                              }
                                            });
                                          }}
                                          className={`w-full text-left px-4 py-2.5 text-sm hover:bg-gray-50 flex items-center gap-3 transition-colors ${resolvedStatus === 'PAUSED' ? 'text-gray-900 bg-gray-50' : 'text-gray-700'}`}
                                        >
                                          <div className="w-2 h-2 rounded-full bg-gray-400" />
                                          <span>Pause</span>
                                          {resolvedStatus === 'PAUSED' && <Check className="w-3.5 h-3.5 ml-auto" />}
                                        </button>
                                      </div>
                                    </>
                                  )}
                                </>
                              );
                            })()}
                            {/* Campaign icon + name */}
                            <div className="w-6 h-6 bg-transparent flex items-center justify-center">
                              <img
                                src="/app.svg"
                                alt="App Campaign"
                                className="w-4 h-4"
                              />
                            </div>
                            <p className="text-[13px] font-medium text-gray-900">{campaign.name || campaign.campaign_name || 'Unnamed Campaign'}</p>
                          </div>
                        </td>
                        {/* Budget td */}
                        <td className="px-6 py-4 whitespace-nowrap text-right border-r border-gray-200" onClick={e => e.stopPropagation()}>
                          {(() => {
                            const live = liveDataMap[String(campaign.id)];
                            const isEditing = editBudget?.id === campaign.id;
                            const displayBudget = live?.budget != null ? live.budget : campaign.budget;
                            const hasBudgetId = !!(live?.budgetId || campaign.budget_id);

                            if (isEditing) {
                              return (
                                <div className="flex items-center justify-end gap-2">
                                  <input
                                    type="number"
                                    value={editBudget.value}
                                    onChange={(e) => setEditBudget({ ...editBudget, value: e.target.value })}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter') handleSaveBudget(campaign.id, campaign.name || campaign.campaign_name);
                                      if (e.key === 'Escape') setEditBudget(null);
                                    }}
                                    className="w-24 px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:border-blue-500"
                                    autoFocus
                                  />
                                  <button onClick={() => handleSaveBudget(campaign.id, campaign.name || campaign.campaign_name)} className="p-1 text-green-600 hover:bg-green-50 rounded">
                                    <Check className="w-4 h-4" />
                                  </button>
                                  <button onClick={() => setEditBudget(null)} className="p-1 text-gray-400 hover:bg-gray-100 rounded">
                                    <X className="w-4 h-4" />
                                  </button>
                                </div>
                              );
                            }

                            return (
                              <div className="flex items-center justify-end gap-2 group">
                                <span className="text-sm text-gray-900 font-medium">
                                  {displayBudget != null ? `₺${displayBudget.toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}` : isLoadingLive ? <Loader2 className="w-3.5 h-3.5 animate-spin text-gray-400 inline" /> : '—'}
                                </span>
                                {hasBudgetId && (
                                  <button
                                    onClick={() => setEditBudget({ id: campaign.id, value: displayBudget || 0 })}
                                    disabled={updatingId === campaign.id}
                                    className="opacity-0 group-hover/row:opacity-100 p-1 text-gray-400 hover:text-blue-600 transition-opacity"
                                  >
                                    <Edit2 className="w-3 h-3" />
                                  </button>
                                )}
                              </div>
                            );
                          })()}
                        </td>
                        {/* Cost td */}
                        <td className="text-right py-2.5 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-900">
                          ₺{formatNumber(campaign.spend || campaign.cost || 0, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                        </td>
                        <td className="text-right py-2.5 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-900">{(campaign.impressions || 0).toLocaleString()}</td>
                        <td className="text-right py-2.5 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-900">{(campaign.clicks || 0).toLocaleString()}</td>
                        <td className="text-right py-2.5 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-900">{isNaN(campaign.ctr) ? '0' : campaign.ctr.toFixed(0)}%</td>
                        <td className="text-right py-2.5 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-900">₺{isNaN(campaign.cpc) ? '0' : campaign.cpc.toFixed(0)}</td>
                        <td className="text-right py-2.5 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-900">{campaign.conversions || 0}</td>
                        <td className="text-right py-2.5 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-900">{isNaN(campaign.conversionRate) ? '0' : campaign.conversionRate.toFixed(0)}%</td>
                        <td className="text-right py-2.5 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-900">
                          ₺{(() => {
                            const cost = campaign.spend || campaign.cost || 0;
                            const installs = campaign.conversions || 0;
                            return installs > 0 ? (cost / installs).toFixed(0) : '0';
                          })()}
                        </td>
                      {hasAdjust && (
                        <>
                          <td className="text-right py-2.5 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-900">{(campaign.adjustSessions || campaign.adjust_sessions || 0).toLocaleString()}</td>
                          <td className="text-right py-2.5 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-900">{(campaign.adjustInstalls || campaign.adjust_installs || 0).toLocaleString()}</td>
                          <td className="text-right py-2.5 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-900">{(campaign.adjustPurchaseEvents || campaign.adjust_purchase_events || 0).toLocaleString()}</td>
                          <td className="text-right py-2.5 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-900">₺{(campaign.adjustAllRevenue || campaign.adjust_all_revenue || 0).toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})}</td>
                        </>
                      )}
                      <td className="text-right py-2.5 px-3 text-[13px] font-medium text-gray-900">{isNaN(campaign.roas) ? '0' : campaign.roas.toFixed(0)}x</td>
                      </tr>

                      {/* Ad Groups Section */}
                      {expandedCampaigns.has(campaign.id) && campaign.adGroups && (
                        <>
                          {sortAdGroups(campaign.adGroups, sortField, sortDirection).map((adGroup) => (
                            <React.Fragment key={adGroup.id}>
                              {/* Ad Group Row */}
                              <tr
                                className="hover:bg-blue-50/20 bg-blue-50/5"
                                onClick={(e) => toggleAdGroup(adGroup.id, e)}
                              >
                                <td className="py-2 px-3 border-r border-gray-200">
                                  <div className="flex items-center gap-2 pl-[2.75rem]">
                                    <div className="flex items-center justify-center w-5 h-5">
                                      {expandedAdGroups.has(adGroup.id) ?
                                        <ChevronDown className="w-4 h-4 text-blue-500" /> :
                                        <ChevronRight className="w-4 h-4 text-gray-400" />
                                      }
                                    </div>
                                    <div className="w-5 h-5 flex items-center justify-center">
                                      <img
                                        src="/enableicon.svg"
                                        alt="Ad Group"
                                        className="w-3 h-3"
                                      />
                                    </div>
                                    <div>
                                      <p className="text-[13px] font-medium text-gray-800">{adGroup.name}</p>
                                    </div>
                                  </div>
                                </td>
                                {/* Budget empty cell */}
                                <td className="text-right py-2 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-400">—</td>
                                <td className="text-right py-2 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-800">₺{formatNumber(adGroup.spend, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                                <td className="text-right py-2 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-800">{(adGroup.impressions || 0).toLocaleString()}</td>
                                <td className="text-right py-2 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-800">{(adGroup.clicks || 0).toLocaleString()}</td>
                                <td className="text-right py-2 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-800">{isNaN(adGroup.ctr) ? '0' : adGroup.ctr.toFixed(0)}%</td>
                                <td className="text-right py-2 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-800">₺{isNaN(adGroup.cpc) ? '0' : adGroup.cpc.toFixed(0)}</td>
                                <td className="text-right py-2 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-800">{adGroup.conversions || 0}</td>
                                <td className="text-right py-2 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-800">{isNaN(adGroup.conversionRate) ? '0' : adGroup.conversionRate.toFixed(0)}%</td>
                                <td className="text-right py-2 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-800">
                                ₺{(() => {
                                  const cost = adGroup.spend || adGroup.cost || 0;
                                  const installs = adGroup.conversions || 0;
                                  return installs > 0 ? (cost / installs).toFixed(0) : '0';
                                })()}
                              </td>
                              {hasAdjust && (
                                <>
                                  <td className="text-right py-2 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-800">—</td>
                                  <td className="text-right py-2 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-800">—</td>
                                  <td className="text-right py-2 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-800">—</td>
                                  <td className="text-right py-2 px-3 border-r border-gray-200 text-[13px] font-medium text-gray-800">—</td>
                                </>
                              )}
                              <td className="text-right py-2 px-3 text-[13px] font-medium text-gray-800">{isNaN(adGroup.roas) ? '0' : adGroup.roas.toFixed(0)}x</td>
                              </tr>

                              {/* Keywords Section */}
                              {expandedAdGroups.has(adGroup.id) && adGroup.keywords && sortKeywords(adGroup.keywords, sortField, sortDirection).map((keyword) => (
                                <tr 
                                  key={keyword.id}
                                  className="hover:bg-blue-50/10 bg-blue-50/2"
                                >
                                  <td className="py-2 px-3 border-r border-gray-200">
                                    <div className="flex items-center gap-2 pl-[5.5rem]">
                                      <p className="text-[12px] font-medium text-gray-700">{keyword.text}</p>
                                      <div className="flex gap-1">
                                        {keyword.matchTypes && keyword.matchTypes.map((matchType, index) => (
                                          <span key={index} className={`text-[10px] px-1.5 py-0.5 rounded-full ${
                                            matchType.includes('EXACT') ? 'bg-blue-100 text-blue-700' :
                                            matchType.includes('PHRASE') ? 'bg-green-100 text-green-700' :
                                            matchType.includes('BROAD') ? 'bg-purple-100 text-purple-700' :
                                            'bg-gray-100 text-gray-600'
                                          }`}>
                                            {matchType.replace('KeywordMatchType.', '').replace('KEYWORD_MATCH_TYPE_', '')}
                                          </span>
                                        ))}
                                      </div>
                                    </div>
                                  </td>
                                  {/* Budget empty cell */}
                                  <td className="text-right py-2 px-3 border-r border-gray-200 text-[12px] font-medium text-gray-400">—</td>
                                  <td className="text-right py-2 px-3 border-r border-gray-200 text-[12px] font-medium text-gray-700">₺{formatNumber(keyword.spend, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                                  <td className="text-right py-2 px-3 border-r border-gray-200 text-[12px] font-medium text-gray-700">{(keyword.impressions || 0).toLocaleString()}</td>
                                  <td className="text-right py-2 px-3 border-r border-gray-200 text-[12px] font-medium text-gray-700">{(keyword.clicks || 0).toLocaleString()}</td>
                                  <td className="text-right py-2 px-3 border-r border-gray-200 text-[12px] font-medium text-gray-700">
                                    {keyword.impressions > 0 ? ((keyword.clicks / keyword.impressions) * 100).toFixed(0) : '0'}%
                                  </td>
                                  <td className="text-right py-2 px-3 border-r border-gray-200 text-[12px] font-medium text-gray-700">
                                    ₺{formatNumber(keyword.clicks > 0 ? (keyword.spend / keyword.clicks) : 0, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                  </td>
                                  <td className="text-right py-2 px-3 border-r border-gray-200 text-[12px] font-medium text-gray-700">{keyword.conversions || 0}</td>
                                  <td className="text-right py-2 px-3 border-r border-gray-200 text-[12px] font-medium text-gray-700">
                                    {keyword.clicks > 0 ? ((keyword.conversions / keyword.clicks) * 100).toFixed(0) : '0'}%
                                  </td>
                                  <td className="text-right py-2 px-3 border-r border-gray-200 text-[12px] font-medium text-gray-700">
                                  ₺{(() => {
                                    const cost = keyword.spend || keyword.cost || 0;
                                    const installs = keyword.conversions || 0;
                                    return installs > 0 ? (cost / installs).toFixed(0) : '0';
                                  })()}
                                </td>
                                {hasAdjust && (
                                  <>
                                    <td className="text-right py-2 px-3 border-r border-gray-200 text-[12px] font-medium text-gray-700">—</td>
                                    <td className="text-right py-2 px-3 border-r border-gray-200 text-[12px] font-medium text-gray-700">—</td>
                                    <td className="text-right py-2 px-3 border-r border-gray-200 text-[12px] font-medium text-gray-700">—</td>
                                    <td className="text-right py-2 px-3 border-r border-gray-200 text-[12px] font-medium text-gray-700">—</td>
                                  </>
                                )}
                                <td className="text-right py-2 px-3 text-[12px] font-medium text-gray-700">
                                  {keyword.spend > 0 ? (keyword.conversionValue / keyword.spend).toFixed(0) : '0'}x
                                </td>
                                </tr>
                              ))}
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </React.Fragment>
                  ));
                })()}
              </tbody>
              {/* Toplam Satırı - Tüm kampanyaların toplamı */}
              <tfoot>
                <tr className="bg-gray-100 border-t-2 border-gray-300">
                  <td className="py-3 px-3 border-r border-gray-200 font-medium text-[13px] text-gray-900">
                    Total
                  </td>
                  {/* Budget column - no total */}
                  <td className="text-right py-3 px-3 border-r border-gray-200">
                  </td>
                  <td className="text-right py-3 px-3 border-r border-gray-200 font-medium text-[13px] text-gray-900">
                    ₺{formatNumber((() => {
                      const campaignsToTotal = appCampaignsData?.campaigns && appCampaignsData.campaigns.length > 0
                        ? appCampaignsData.campaigns
                        : sortedCampaigns;
                      return campaignsToTotal.reduce((total, campaign) => total + (campaign.spend || campaign.cost || 0), 0);
                    })(), { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                  </td>
                  <td className="text-right py-3 px-3 border-r border-gray-200 font-medium text-[13px] text-gray-900">
                    {(() => {
                      const campaignsToTotal = appCampaignsData?.campaigns && appCampaignsData.campaigns.length > 0 
                        ? appCampaignsData.campaigns 
                        : sortedCampaigns;
                      return campaignsToTotal.reduce((total, campaign) => total + (campaign.impressions || 0), 0).toLocaleString();
                    })()}
                  </td>
                  <td className="text-right py-3 px-3 border-r border-gray-200 font-medium text-[13px] text-gray-900">
                    {(() => {
                      const campaignsToTotal = appCampaignsData?.campaigns && appCampaignsData.campaigns.length > 0 
                        ? appCampaignsData.campaigns 
                        : sortedCampaigns;
                      return campaignsToTotal.reduce((total, campaign) => total + (campaign.clicks || 0), 0).toLocaleString();
                    })()}
                  </td>
                  <td className="text-right py-3 px-3 border-r border-gray-200 font-medium text-[13px] text-gray-900">
                    {(() => {
                      const campaignsToTotal = appCampaignsData?.campaigns && appCampaignsData.campaigns.length > 0 
                        ? appCampaignsData.campaigns 
                        : sortedCampaigns;
                      const totalImpressions = campaignsToTotal.reduce((total, campaign) => total + (campaign.impressions || 0), 0);
                      const totalClicks = campaignsToTotal.reduce((total, campaign) => total + (campaign.clicks || 0), 0);
                      return totalImpressions > 0 ? ((totalClicks / totalImpressions) * 100).toFixed(0) : '0';
                    })()}%
                  </td>
                  <td className="text-right py-3 px-3 border-r border-gray-200 font-medium text-[13px] text-gray-900">
                    ₺{(() => {
                      const campaignsToTotal = appCampaignsData?.campaigns && appCampaignsData.campaigns.length > 0 
                        ? appCampaignsData.campaigns 
                        : sortedCampaigns;
                      const totalClicks = campaignsToTotal.reduce((total, campaign) => total + (campaign.clicks || 0), 0);
                      const totalSpend = campaignsToTotal.reduce((total, campaign) => total + (campaign.spend || campaign.cost || 0), 0);
                      return totalClicks > 0 ? (totalSpend / totalClicks).toFixed(0) : '0';
                    })()}
                  </td>
                  <td className="text-right py-3 px-3 border-r border-gray-200 font-medium text-[13px] text-gray-900">
                    {(() => {
                      const campaignsToTotal = appCampaignsData?.campaigns && appCampaignsData.campaigns.length > 0 
                        ? appCampaignsData.campaigns 
                        : sortedCampaigns;
                      return campaignsToTotal.reduce((total, campaign) => total + (campaign.conversions || 0), 0).toLocaleString();
                    })()}
                  </td>
                  <td className="text-right py-3 px-3 border-r border-gray-200 font-medium text-[13px] text-gray-900">
                    {(() => {
                      const campaignsToTotal = appCampaignsData?.campaigns && appCampaignsData.campaigns.length > 0 
                        ? appCampaignsData.campaigns 
                        : sortedCampaigns;
                      const installRateClicks = campaignsToTotal.reduce((total, campaign) => total + (campaign.clicks || 0), 0);
                      const installRateConversions = campaignsToTotal.reduce((total, campaign) => total + (campaign.conversions || 0), 0);
                      return installRateClicks > 0 ? ((installRateConversions / installRateClicks) * 100).toFixed(0) : '0';
                    })()}%
                  </td>
                  <td className="text-right py-3 px-3 border-r border-gray-200 font-medium text-[13px] text-gray-900">
                    ₺{(() => {
                      const campaignsToTotal = appCampaignsData?.campaigns && appCampaignsData.campaigns.length > 0 
                        ? appCampaignsData.campaigns 
                        : sortedCampaigns;
                      const costPerInstallConversions = campaignsToTotal.reduce((total, campaign) => total + (campaign.conversions || 0), 0);
                      const costPerInstallSpend = campaignsToTotal.reduce((total, campaign) => total + (campaign.spend || campaign.cost || 0), 0);
                      return costPerInstallConversions > 0 ? (costPerInstallSpend / costPerInstallConversions).toFixed(0) : '0';
                    })()}
                  </td>
                  {hasAdjust && (
                    <>
                      <td className="text-right py-3 px-3 border-r border-gray-200 font-medium text-[13px] text-gray-900">
                        {(() => {
                          const campaignsToTotal = appCampaignsData?.campaigns && appCampaignsData.campaigns.length > 0 
                            ? appCampaignsData.campaigns 
                            : sortedCampaigns;
                          return campaignsToTotal.reduce((total, campaign) => total + (campaign.adjustSessions || campaign.adjust_sessions || 0), 0).toLocaleString();
                        })()}
                      </td>
                      <td className="text-right py-3 px-3 border-r border-gray-200 font-medium text-[13px] text-gray-900">
                        {(() => {
                          const campaignsToTotal = appCampaignsData?.campaigns && appCampaignsData.campaigns.length > 0 
                            ? appCampaignsData.campaigns 
                            : sortedCampaigns;
                          return campaignsToTotal.reduce((total, campaign) => total + (campaign.adjustInstalls || campaign.adjust_installs || 0), 0).toLocaleString();
                        })()}
                      </td>
                      <td className="text-right py-3 px-3 border-r border-gray-200 font-medium text-[13px] text-gray-900">
                        {(() => {
                          const campaignsToTotal = appCampaignsData?.campaigns && appCampaignsData.campaigns.length > 0 
                            ? appCampaignsData.campaigns 
                            : sortedCampaigns;
                          return campaignsToTotal.reduce((total, campaign) => total + (campaign.adjustPurchaseEvents || campaign.adjust_purchase_events || 0), 0).toLocaleString();
                        })()}
                      </td>
                      <td className="text-right py-3 px-3 border-r border-gray-200 font-medium text-[13px] text-gray-900">
                        ₺{(() => {
                          const campaignsToTotal = appCampaignsData?.campaigns && appCampaignsData.campaigns.length > 0 
                            ? appCampaignsData.campaigns 
                            : sortedCampaigns;
                          return formatNumber(campaignsToTotal.reduce((total, campaign) => total + (campaign.adjustAllRevenue || campaign.adjust_all_revenue || 0), 0), { minimumFractionDigits: 0, maximumFractionDigits: 0 });
                        })()}
                      </td>
                    </>
                  )}
                  <td className="text-right py-3 px-3 font-medium text-[13px] text-gray-900">
                    {(() => {
                      const campaignsToTotal = appCampaignsData?.campaigns && appCampaignsData.campaigns.length > 0 
                        ? appCampaignsData.campaigns 
                        : sortedCampaigns;
                      const totalSpend = campaignsToTotal.reduce((total, campaign) => total + (campaign.spend || campaign.cost || 0), 0);
                      const totalRevenue = campaignsToTotal.reduce((total, campaign) => total + (campaign.revenue || campaign.conversionValue || 0), 0);
                      return totalSpend > 0 ? (totalRevenue / totalSpend).toFixed(0) : '0';
                    })()}x
                  </td>
                </tr>
              </tfoot>
            </table>
          )}
        </div>
      </Card>

      {/* Custom date modal removed — <DateRangeFilter /> owns the calendar popover now */}

      {/* Change History Slide-over */}
      {showChangeHistory && (
        <div className="fixed inset-0 z-50 flex justify-end">
          <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" onClick={() => setShowChangeHistory(false)} />
          <div className="relative w-full max-w-lg bg-white shadow-2xl flex flex-col animate-in slide-in-from-right duration-200">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-xl bg-indigo-50 flex items-center justify-center">
                  <History className="w-5 h-5 text-indigo-600" />
                </div>
                <div>
                  <h2 className="text-base font-semibold text-gray-900">Change History</h2>
                  <p className="text-xs text-gray-500">{changeHistoryTotal} total changes</p>
                </div>
              </div>
              <button onClick={() => setShowChangeHistory(false)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
                <X className="w-5 h-5 text-gray-400" />
              </button>
            </div>
            <div className="px-6 py-3 border-b border-gray-50 flex gap-2">
              {[
                { key: 'all', label: 'All' },
                { key: 'status_change', label: 'Status' },
                { key: 'budget_change', label: 'Budget' }
              ].map(f => (
                <button
                  key={f.key}
                  onClick={() => setChangeHistoryFilter(f.key)}
                  className={`px-3 py-1.5 text-xs font-medium rounded-lg transition-colors ${
                    changeHistoryFilter === f.key
                      ? 'bg-indigo-100 text-indigo-700'
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  {f.label}
                </button>
              ))}
            </div>
            <div className="flex-1 overflow-y-auto px-6 py-4 space-y-3">
              {changeHistoryLoading && changeHistoryData.length === 0 ? (
                <div className="flex items-center justify-center py-12">
                  <Loader2 className="w-6 h-6 animate-spin text-indigo-500" />
                </div>
              ) : changeHistoryData.length === 0 ? (
                <div className="text-center py-12">
                  <History className="w-10 h-10 text-gray-300 mx-auto mb-3" />
                  <p className="text-sm text-gray-500">No changes recorded yet</p>
                  <p className="text-xs text-gray-400 mt-1">Changes to campaigns will appear here</p>
                </div>
              ) : (
                <>
                  {changeHistoryData.map((item, idx) => {
                    const isStatus = item.action === 'status_change';
                    const isBudget = item.action === 'budget_change';
                    const timeAgo = (() => {
                      const diff = Date.now() - new Date(item.created_at).getTime();
                      const mins = Math.floor(diff / 60000);
                      if (mins < 1) return 'Just now';
                      if (mins < 60) return `${mins}m ago`;
                      const hours = Math.floor(mins / 60);
                      if (hours < 24) return `${hours}h ago`;
                      const days = Math.floor(hours / 24);
                      if (days < 7) return `${days}d ago`;
                      return new Date(item.created_at).toLocaleDateString('tr-TR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
                    })();
                    const formatValue = (val, field) => {
                      if (!val) return '—';
                      if (field === 'amount_micros' || field === 'daily_budget') {
                        const num = parseFloat(val) / 1000000;
                        return `₺${num.toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
                      }
                      return val;
                    };
                    return (
                      <div key={item.id || idx} className={`p-3.5 rounded-xl border transition-colors ${item.success ? 'border-gray-100 bg-white hover:bg-gray-50/50' : 'border-red-100 bg-red-50/30'}`}>
                        <div className="flex items-start justify-between gap-3">
                          <div className="flex items-start gap-3 min-w-0 flex-1">
                            <div className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center mt-0.5 ${
                              !item.success ? 'bg-red-100' : isStatus ? 'bg-amber-100' : isBudget ? 'bg-blue-100' : 'bg-gray-100'
                            }`}>
                              {!item.success ? <XCircle className="w-4 h-4 text-red-500" /> :
                               isStatus ? <Activity className="w-4 h-4 text-amber-600" /> :
                               <DollarSign className="w-4 h-4 text-blue-600" />}
                            </div>
                            <div className="min-w-0 flex-1">
                              <div className="flex items-center gap-2 flex-wrap">
                                <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-semibold uppercase tracking-wider ${
                                  isStatus ? 'bg-amber-100 text-amber-700' : isBudget ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600'
                                }`}>
                                  {isStatus ? 'Status' : isBudget ? 'Budget' : item.action}
                                </span>
                                <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium ${
                                  item.platform === 'GOOGLE_ADS' ? 'bg-emerald-50 text-emerald-600' : 'bg-blue-50 text-blue-600'
                                }`}>
                                  {item.platform === 'GOOGLE_ADS' ? 'Google' : 'Meta'}
                                </span>
                              </div>
                              {item.entity_name && (
                                <p className="text-sm font-medium text-gray-800 mt-1 truncate">{item.entity_name}</p>
                              )}
                              <div className="flex items-center gap-1.5 mt-1 text-xs">
                                <span className="text-gray-400">{formatValue(item.old_value, item.field_name)}</span>
                                <span className="text-gray-300">→</span>
                                <span className={`font-medium ${item.success ? 'text-gray-700' : 'text-red-600'}`}>
                                  {formatValue(item.new_value, item.field_name)}
                                </span>
                              </div>
                              {!item.success && item.error_message && (
                                <p className="text-xs text-red-500 mt-1 truncate">{item.error_message}</p>
                              )}
                            </div>
                          </div>
                          <div className="flex-shrink-0 text-right">
                            <div className="flex items-center gap-1 text-[11px] text-gray-400">
                              <Clock className="w-3 h-3" />
                              {timeAgo}
                            </div>
                            {item.user_email && (
                              <p className="text-[10px] text-gray-400 mt-0.5 truncate max-w-[120px]">{item.user_name || item.user_email}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {changeHistoryData.length < changeHistoryTotal && (
                    <button
                      onClick={() => fetchChangeHistory(changeHistoryData.length, true)}
                      disabled={changeHistoryLoading}
                      className="w-full py-2.5 text-sm font-medium text-indigo-600 hover:bg-indigo-50 rounded-xl transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
                    >
                      {changeHistoryLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
                      Load More ({changeHistoryTotal - changeHistoryData.length} remaining)
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}